//============================================= Entry Point ========================================================//
const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

const __virtual = "Virtual";
const __inPerson = "In Person";
const __virtualTour = "Virtual Tour";
const __inPersonTour = "In Person Tour";
const __selfGuided = "Self-Guided";
const __duringBusnessHours = "Walk-in";
const __origin = "web";
const __contactType = "Meritagehomes.com Forms";
const __primaryLeadSource = "Website Forms";
const __leadSource = "Web";
const __subSource = "MH.com";
const __Error101 =
    "We’re sorry, but the time you selected was already booked. Please close this window and try again.";
const __Error303 =
    "We’re sorry, but the time you selected was already booked.Please close this window and try again.";
const __Error333 =
    "We're sorry, but our appointment booking service is currently unavailable.";
const __Error403 =
    "We’re sorry, but our appointment booking service experienced an issue. Please close this window and try again.";
const __Error409 =
    "We’re sorry, but the appointment booking service encountered an issue. Please close this window and try again.";

const SalesforceTourScheduleState = {
    WorkPages: [],
    WorkPageButtons: [],
    ConfirmationPages: [],
    ConfirmatonPageButtons: [],
};

var SalesforceTourSchedulerCarouselDestroy = null;

$(document).ready(function () {
    $(".dropdown-with-autocomplete").select2({
        theme: "foundation",
    });

    //var AppointmentOnly = $("#salesforce-tour-schedule-form-modal").data("appointment-only");
    //var SelfGuidedTourAvailable = $("#salesforce-tour-schedule-form-modal").data("self-guided");

    //var payload = {
    //    Trigger = "Initialization",
    //    AppointmentOnly = AppointmentOnly,
    //    SelfGuidedTourAvailable: SelfGuidedTourAvailable
    //};

    ////InitializeTourModal_action(payload);

    InitializeOuterCarousel();
    InitializeWorkPages();
    InitializeConfirmationPages();
    InitializeSalesforceschedulerWizard();
    InitializeRegisterPage();
    InitializeWebForm();

    $('[data-open="salesforce-tour-schedule-form-modal"]').on(
        "click touchstart keypress",
        function () {
            //ClearCarouselSelection();
            //SalesforceSchedulerClearErrors();
            var carouselStartTime = new Date();
            carouselStartTime = new Date(
                carouselStartTime.getFullYear(),
                carouselStartTime.getMonth(),
                carouselStartTime.getDate()
            );
            let rawDateTime = $(this).data("date");
            var selectedDateParts = rawDateTime.split("-");
            var selectedDatetime = new Date(
                selectedDateParts[0],
                selectedDateParts[1] - 1,
                selectedDateParts[2]
            );
            let date = new Date(selectedDatetime);
            $(this).data("selected-card", date.getDate());
            $(this).data(
                "selected-date",
                date.getMonth() + "/" + date.getDate() + "/" + date.getFullYear()
            );
            //console.log("InitializeDateSelection");
            InitializeDateSelection(carouselStartTime, selectedDatetime);
            SFC_SetSelfGuidedTourLink();
            initWorkFlow();
            $("#TourAddress").val($(".bookTourButton").data("address-full"));
            var metroDefultPhNo = $(".bookTourButton").data("help-phone");
            $("#HelpPhone").text(formatPhoneNumber(metroDefultPhNo));
        }
    );
});

//============================================= Entry Point End ========================================================//

//============================================= Entry Point Start ======================================================//

let SCFModalBreadcrump = function (_workflow) {
    let stateName, metroName, communityName;

    if ($("#salesforce-tour-schedule-form-modal").attr("data-state-name")) {
        stateName = $("#salesforce-tour-schedule-form-modal").attr(
            "data-state-name"
        );
    }
    if ($("#salesforce-tour-schedule-form-modal").attr("data-metro-name")) {
        metroName = $("#salesforce-tour-schedule-form-modal").attr(
            "data-metro-name"
        );
    }
    if ($("#salesforce-tour-schedule-form-modal").attr("data-community-name")) {
        communityName = $("#salesforce-tour-schedule-form-modal").attr(
            "data-community-name"
        );
    }

    $("#SFC_ModalBreadcrump").empty();

    let bcPrefix = stateName + " > " + metroName + " > " + communityName;

    let $step0 = $("<span />").html(bcPrefix);
    $("#SFC_ModalBreadcrump").append($step0);

    for (let i = 0; i <= _workflow.previousStates.length - 1; i++) {
        if (_workflow.previousStates[i].value.notClickable == false) {
            let $step = $("<a />")
                .attr("href", "#")
                .attr("data-prev-step", _workflow.previousStates[i].value.prevStepKey)
                .html(_workflow.previousStates[i].value.stepSelectionCaption)
                .click(function () {
                    $("#" + _workflow.currentStepKey).addClass("scheduler-page-hidden");
                    $("#" + _workflow.currentStepKey).removeClass(
                        "scheduler-page-visible"
                    );

                    let newStates = new Array();
                    let continueWhile = true;
                    let idx = 0;
                    do {
                        if (
                            _workflow.previousStates[idx].name ==
                            $(this).attr("data-prev-step")
                        ) {
                            if (_workflow.previousStates[idx].value) {
                                let newWorkflowData = {};

                                const workflowData = _workflow.previousStates[idx].value;

                                //console.log(workflowData.previousStates);

                                if (workflowData.previousStates.length == 0) {
                                    newWorkflowData = new Workflow();
                                    newWorkflowData.currentStepKey = "SFC_Init";
                                    newWorkflowData.prevStepKey = "SFC_Init";
                                    newWorkflowData.setCurrentStepIdx(0);
                                    _workflow = workflow = newWorkflowData;
                                    //console.log("has no data");
                                    //console.log(workflowData);
                                } else {
                                    //console.log("has data");
                                    //console.log(workflowData.previousStates);
                                    _workflow = workflow =
                                        workflowData.previousStates[
                                            workflowData.previousStates.length - 1
                                        ].value;
                                }
                            }

                            continueWhile = false;
                        }

                        idx++;
                    } while (continueWhile);

                    _workflow.renderStep();

                    SCFModalBreadcrump(_workflow.getWorkflow());
                });
            $("#SFC_ModalBreadcrump").append($step);
        } else {
            let $step = $("<span />")
                .text(_workflow.previousStates[i].value.stepSelectionCaption)
                .css("display", "block");
            $("#SFC_ModalBreadcrump").append($step);
        }
    }
};

let SFCUpdateSteps = function (currentStepKey, prevStepKey) {
    if ($("#" + currentStepKey).length) {
        $("#" + currentStepKey).addClass("scheduler-page-visible");
        $("#" + currentStepKey).removeClass("scheduler-page-hidden");
    }

    if ($("#" + prevStepKey).length) {
        $("#" + prevStepKey).addClass("scheduler-page-hidden");
        $("#" + prevStepKey).removeClass("scheduler-page-visible");
    }
};

let Workflow = function () {
    let tourType;
    let tourParty;

    let tourSelectedDate;

    let currentStepKey;

    let prevStepKey;

    let workflowPageSufix = "";

    let currentStepIdx = 0;

    let erroCallbackPage = "";

    let currentStepOptions = new Array();

    let workflowPages = [
        { name: "SFC_Init", key: "SFC_TourPartyPage", prefix: "" },
        { name: "SFC_TourPartyPage", key: "SFC_TourTypePage", prefix: "WS" },
        { name: "SFC_TourPartyPage", key: "SFC_TourTypePage", prefix: "WOS" },
        { name: "SFC_TourTypePage", key: "SFC_TourSchedulePage", prefix: "WS_IP" },
        { name: "SFC_TourTypePage", key: "SFC_TourSchedulePage", prefix: "WS_VT" },
        {
            name: "SFC_TourTypePage",
            key: "SFC_TourBusinessHoursPage",
            prefix: "WOS_IP",
        },
        { name: "SFC_TourTypePage", key: "SFC_TourVideoPage", prefix: "WOS_VT" },
        {
            name: "SFC_TourSchedulePage",
            key: "SFC_TourRegistrationPage",
            prefix: "WS_IP",
        },
        {
            name: "SFC_TourSchedulePage",
            key: "SFC_TourRegistrationPage",
            prefix: "WS_VT",
        },
        {
            name: "SFC_TourBusinessHoursPage",
            key: "SFC_TourRegistrationPage",
            prefix: "WOS_IP",
        },
        {
            name: "SFC_TourVideoPage",
            key: "SFC_TourRegistrationPage",
            prefix: "WOS_VT",
        },
        {
            name: "SFC_TourRegistrationPage",
            key: "SFC_TourThankYouPage_WSIP",
            prefix: "WS_IP",
            onErr: "SFC_ErrorPage",
        },
        {
            name: "SFC_TourRegistrationPage",
            key: "SFC_TourThankYouPage_WSVT",
            prefix: "WS_VT",
            onErr: "SFC_ErrorPage",
        },
        {
            name: "SFC_TourRegistrationPage",
            key: "SFC_TourThankYouPage_WOSIP",
            prefix: "WOS_IP",
            onErr: "SFC_ErrorPage",
        },
        {
            name: "SFC_TourRegistrationPage",
            key: "SFC_TourThankYouPage_WOSVT",
            prefix: "WOS_VT",
            onErr: "SFC_ErrorPage",
        },
    ];

    return {
        onErr: false,

        stepSelectionCaption: "",

        previousStates: [],

        notClickable: false,

        setClickable: function (clk) {
            this.notClickable = clk;
            return this;
        },

        setCurrentStepIdx: function (csi) {
            this.currentStepIdx = csi;
            return this;
        },

        setCurrentStepKey: function (csk) {
            this.currentStepKey = csk;
            return this;
        },

        setPrevStepKey: function (psk) {
            this.prevStepKey = psk;
            return this;
        },

        setTourSelectedDate: function (sd) {
            this.tourSelectedDate = sd;
            return this;
        },

        setTourType: function (tt) {
            this.tourType = tt;
            return this;
        },

        setTourParty: function (tp) {
            this.tourParty = tp;
            return this;
        },

        changeCurrentStep: function (_currentStep) {
            this.currentStep = _currentStep;
            return this;
        },

        getWorkflow: function () {
            return this;
        },

        renderStep: function () {
            let that = {};

            that = _.cloneDeep(this);

            this.prevStepKey = this.currentStepKey;

            this.workflowPages = workflowPages;

            if (this.tourParty == "WS") {
                workflowPageSufix = "WS";

                if (this.tourType == "IP") {
                    workflowPageSufix += "_IP";
                }

                if (this.tourType == "VT") {
                    workflowPageSufix += "_VT";
                }
            }

            if (this.tourParty == "WOS") {
                workflowPageSufix = "WOS";

                if (this.tourType == "IP") {
                    workflowPageSufix += "_IP";
                }

                if (this.tourType == "VT") {
                    workflowPageSufix += "_VT";
                }
            }

            var findStep = function (_currentStepKey) {
                return function (item) {
                    if (
                        item.name === _currentStepKey &&
                        item.prefix === workflowPageSufix
                    ) {
                        return item;
                    }
                };
            };

            var currentPageItem = this.workflowPages.filter(
                findStep(this.currentStepKey)
            );

            if (currentPageItem.length > 0) {
                if (this.onErr) {
                    this.currentStepKey = currentPageItem[0].onErr;
                } else {
                    this.currentStepKey = currentPageItem[0].key;
                }
            }

            SFCUpdateSteps(this.currentStepKey, this.prevStepKey);

            this.currentStepIdx += 1;

            UpdateStepProgress(this.currentStepIdx);

            this.previousStates.push({ name: that.prevStepKey, value: that }); //Keep track of steps

            return this;
        },
    };
};

function UpdateStepProgress(currentStepIdx) {
    if (currentStepIdx == 2) {
        $("#step_img_1").css("display", "inline-block");
        $("#step_img_2").css("display", "none");
        $("#step_img_3").css("display", "none");
    } else if (currentStepIdx == 3) {
        $("#step_img_2").css("display", "inline-block");
        $("#step_img_1").css("display", "none");
        $("#step_img_3").css("display", "none");
    } else if (currentStepIdx == 4) {
        $("#step_img_3").css("display", "inline-block");
        $("#step_img_1").css("display", "none");
        $("#step_img_2").css("display", "none");
    } else {
        $("#step_img_1").attr("display:none");
        $("#step_img_2").css("display", "none");
        $("#step_img_3").css("display", "none");
    }
}

var workflow;

function initWorkFlow() {
    workflow = new Workflow();

    workflow.setClickable(true);
    workflow.setCurrentStepKey("SFC_TourPartyPage");
    workflow.setPrevStepKey("SFC_Init");
    workflow.setCurrentStepIdx(1);

    $("#SFC_TourPartyPage").addClass("scheduler-page-visible");
    $("#SFC_TourPartyPage").removeClass("scheduler-page-hidden");

    UpdateStepProgress(1);

    SCFModalBreadcrump(workflow.getWorkflow());

    $("#SFC_TourPartyBtn").unbind("click");
    $("#SFC_TourPartyBtn").on("click", () => {
        if ($("input[name=tourWithCounselor]:checked").val() === "counselorY") {
            workflow.setTourParty("WS");
            workflow.stepSelectionCaption = "With a Sales Counselor";
        } else {
            workflow.setTourParty("WOS");
            workflow.stepSelectionCaption = "Explore on your own";
        }

        workflow.notClickable = false;
        workflow.renderStep();

        ResetTourTypeComponent();
        SCFModalBreadcrump(workflow.getWorkflow());
    });

    $("#SFC_TourTypeBtn").unbind("click");
    $("#SFC_TourTypeBtn").on("click", () => {
        if ($("input[name=tourtype]:checked").val() === "in-person") {
            workflow.setTourType("IP");
            workflow.stepSelectionCaption = "In Person";
        } else {
            workflow.setTourType("VT");
            workflow.stepSelectionCaption = "Virtually";
        }
        workflow.notClickable = false;
        workflow.renderStep();

        ResetTourScheduleComponent();
        SCFModalBreadcrump(workflow.getWorkflow());
    });

    $("#SFC_TourSchedulePageBtn").unbind("click");
    $("#SFC_TourSchedulePageBtn").on("click", () => {
        workflow.stepSelectionCaption = $(".TimeSlot.TimeSlotSelected").attr(
            "data-time-slot-date"
        );
        workflow.notClickable = false;
        workflow.renderStep();

        ResetTourRegistration();
        SCFModalBreadcrump(workflow.getWorkflow());
    });

    $(".SFC_TourScheduleBusinessHoursBtn").unbind("click");
    $(".SFC_TourScheduleBusinessHoursBtn").on("click", () => {
        workflow.notClickable = false;
        workflow.renderStep();
    });

    $("#BookYourTourNow").unbind("click");
    $("#BookYourTourNow").on("click", function (event) {
        event.preventDefault();
        if ($(this).data("verified") == false) {
            ShowSalesforceRecaptchaError();
            $(this).prop("disabled", true);
        } else {
            HideSalesforceRecaptchaError();
            event.preventDefault();

            //var exploreOnOwn = $("#counselorN").prop("checked");
            //if (exploreOnOwn) {
            //    SelfGuidedDuringBusinessTourAction();
            //}
            //else {
            //}
            RegisterPageSubmit_action();
        }
    });

    //ByPass First Page

    workflow.setTourParty("WS");
    workflow.stepSelectionCaption = "With a Sales Counselor";

    workflow.renderStep();

    ResetTourTypeComponent();
    SCFModalBreadcrump(workflow.getWorkflow());
}

function ResetTourPartyComponent() {
    if ($("#counselorY").length > 0) $("#counselorY").prop("checked", true);
    if ($("#counselorN".length > 0)) $("#counselorN").prop("checked", false);
}

function ResetTourTypeComponent() {
    if ($("#in-person").length > 0) $("#in-person").prop("checked", true);
    if ($("#virtually").length > 0) $("#virtually").prop("checked", false);
}

function ResetTourScheduleComponent() {
    $("#SFC_TourSchedulePageBtn").addClass("hide");
    if ($(".TimeSlot.TimeSlotSelected").length > 0) {
        $(".TimeSlot.TimeSlotSelected").removeClass("TimeSlotSelected");
    }
}

function ResetTourRegistration() {
    $("#HomebuyerFirstName").val(null);
    $("#HomebuyerLastName").val(null);
    $("#HomebuyerEmailAddress").val(null);
    $("#HomebuyerMobilePhoneNumber").val(null);
    $("#AgentFirstName").val(null);
    $("#AgentLastName").val(null);
    $("#AgentEmailAddress").val(null);
    $("#AgentMobilePhoneNumber").val(null);
    $("#AgentAgency").val(null);
    $("#AgentZipcode").val(null);
    $("#SFC_UtourClickRedirect").attr("href", null);

    if (!$("#SFC_HomebuyerCheckbox").prop("checked"))
        $("#SFC_HomebuyerCheckbox").trigger("click");
    $("#SFC_HomebuyerCheckbox").prop("checked", true);

    if ($("#SFC_AgentCheckbox").prop("checked"))
        $("#SFC_AgentCheckbox").trigger("click");
    $("#SFC_AgentCheckbox").prop("checked", false);
    $("#HelpPhone").text(null);
}

function ResetError() {
    $("#SFC_ErrorPage_Message").text($("#SFC_ErrorPage_Default").text());
}

function ResetUIControls() {
    $("#SFC_ModalBreadcrump").empty();
    //ResetTourPartyComponent();
    ResetTourTypeComponent();
    ResetTourScheduleComponent();
    ResetTourRegistration();
    ResetError();
}

const InitializeOuterCarousel = () => {
    var idCount = 0;

    $(".tour-scheduler.salesforce").each(function () {
        var tourSchedulerID = "tour-scheduler-id-" + idCount;
        var tourSchedulerSelector = "#" + tourSchedulerID;

        $(this).attr("id", tourSchedulerID);

        $(document).on(
            "click",
            tourSchedulerSelector + " .tour-scheduler-date-selector",
            function () {
                $(tourSchedulerSelector + " .bookTourButton").data(
                    "date",
                    $(this).data("date")
                );
                $(tourSchedulerSelector + " #tour_schedule_date_picker").val(
                    $(this).data("date")
                );
                $(
                    tourSchedulerSelector +
                    " .tour-scheduler-date-selector .date-selected"
                ).removeClass("date-selected");
                $(this)
                    .find(".tour-scheduler-date-selector-date")
                    .addClass("date-selected");
            }
        );

        $(document).on(
            "click",
            tourSchedulerSelector + " #selfGuidedTourButton",
            function () {
                var utourLink = $(this).data("link");
                utourLink = utourLink + "&desiredDate=" + $(this).data("date");
                $(this).attr("href", utourLink);
            }
        );

        $(tourSchedulerSelector)
            .find("#virtualButton")
            .on("click", virtualButtonClick);
        $(tourSchedulerSelector)
            .find("#inPersonButton")
            .on("click", inPersonButtonClick);

        var slider = tns({
            container: tourSchedulerSelector + " .my-slider",
            items: 3,
            slideBy: "page",
            autoplay: false,
            loop: false,
            controlsContainer:
                tourSchedulerSelector + " .tour-schedule-date-slider-controls",
        });

        $(document).on(
            "click",
            tourSchedulerSelector + " .slider-controls-button",
            function () {
                var sliderInfo = slider.getInfo();

                if (sliderInfo.displayIndex == 1) {
                    $(tourSchedulerSelector + " .prev").addClass("hide");
                } else {
                    $(tourSchedulerSelector + " .prev").removeClass("hide");
                }

                if (sliderInfo.displayIndex == 12) {
                    $(tourSchedulerSelector + " .next").addClass("hide");
                } else {
                    $(tourSchedulerSelector + " .next").removeClass("hide");
                }
            }
        );

        $("#tour_schedule_date_picker").on("change", function () {
            fetchTourData();
        });

        function initTourType(bookATourButton) {
            var buttonParent = $(bookATourButton).parents(".tour-scheduler");
            var tourType;
            if ($(buttonParent).find("#inperson").val() === "selected") {
                tourType = "inperson";
            } else if ($(buttonParent).find("#virtual").val() === "selected") {
                tourType = "virtual";
            }

            return tourType;
        }

        function virtualButtonClick() {
            $(this).addClass("tour-selected");
            $(this).siblings("#inPersonButton").removeClass("tour-selected");
            $(this).siblings("#virtual").val("selected");
            $(this).siblings("#inperson").val("");
        }

        function inPersonButtonClick() {
            $(this).addClass("tour-selected");
            $(this).siblings("#virtualButton").removeClass("tour-selected");
            $(this).siblings("#inperson").val("selected");
            $(this).siblings("#virtual").val("");
        }

        idCount++;
    });
};

const InitializeWorkPages = () => {
    SalesforceTourScheduleState.WorkPages = [];
    $("#SFC_WorkContainer")
        .children()
        .each(function () {
            SalesforceTourScheduleState.WorkPages.push($(this).attr("id"));
        });

    var id = 1;
    SalesforceTourScheduleState.WorkPageButtons = [];
    SalesforceTourScheduleState.WorkPages.forEach((page) => {
        /*const buttonId = page.replace("Page", "Button");
            SalesforceTourScheduleState.WorkPageButtons.push(buttonId);
            $("#SFC_PageNavigation").append(`<button id='${buttonId}'>${id}</button>`);
            $("#" + buttonId).on("click", (buttonId) => {
                event.preventDefault();
               // SFC_ChangePage(page);
            })*/
        id++;
    });

    let width = Math.floor(
        100 / SalesforceTourScheduleState.WorkPageButtons.length
    );
    SalesforceTourScheduleState.WorkPageButtons.forEach((button) => {
        $(`#${button}`).css("width", `${width}%`);
    });

    if (
        SalesforceTourScheduleState.WorkPages != null &&
        SalesforceTourScheduleState.WorkPages.length > 0
    )
        SFC_ChangePage(SalesforceTourScheduleState.WorkPages[0]);
};

const InitializeConfirmationPages = () => {
    SalesforceTourScheduleState.ConfirmationPages = [];
    $("#SFC_ConfirmationContainer")
        .children()
        .each(function () {
            SalesforceTourScheduleState.ConfirmationPages.push($(this).attr("id"));
        });

    var id = 1;
    SalesforceTourScheduleState.ConfirmatonPageButtons = [];
    SalesforceTourScheduleState.ConfirmationPages.forEach((page) => {
        id++;
    });

    let width = Math.floor(
        100 / SalesforceTourScheduleState.ConfirmatonPageButtons.length
    );
    SalesforceTourScheduleState.ConfirmatonPageButtons.forEach((button) => {
        $(`#${button}`).css("width", `${width}%`);
    });

    if (
        SalesforceTourScheduleState.ConfirmationPages != null &&
        SalesforceTourScheduleState.ConfirmationPages.length > 0
    )
        SFC_ChangePage(SalesforceTourScheduleState.ConfirmationPages[0]);
};

const SFC_SetSelfGuidedTourLink = () => {
    var selfGuidedAvailable = $("#salesforce-tour-schedule-form-modal").data(
        "self-guided"
    );
    if (selfGuidedAvailable) {
        $("#SFC_SelfGuidedWrapper").show();
        $("#SFC_UtourClickRedirect").attr(
            "href",
            $("#salesforce-tour-schedule-form-modal").data("self-guided-url")
        );
    } else {
        $("#SFC_SelfGuidedWrapper").hide();
        $("#SFC_UtourClickRedirect").attr("href", null);
    }
};

const SFC_ChangePage = (id) => {
    //SalesforceTourScheduleState.WorkPages.forEach(page => {
    //    if ($(`#${page}`).attr("id") == id)
    //        $(`#${page}`).css("display", "unset");
    //    else
    //        $(`#${page}`).css("display", "none");
    //});
};

const SFC_ChangeConfirmationPage = (id) => {
    //SalesforceTourScheduleState.ConfirmationPages.forEach(page => {
    //    if ($(`#${page}`).attr("id") == id)
    //        $(`#${page}`).css("display", "unset");
    //    else
    //        $(`#${page}`).css("display", "none");
    //});
};

const InitializeVideoTourFloorPlanData_action = () => {
    return SFC_VideoTourFloorPlanSetLoading_promise()
        .then(SFC_RetrieveVideoTourFloorPlan_promise)
        .then(SFC_ClearVideoTourFloorPlanData_promise())
        .then(SFC_SetVideoTourFloorPlanData_promise)
        .catch((error) => {
            console.log(error);
        })
        .finally(() => {
            return SFC_VideoTourFloorPlanClearLoading_promise();
        });
};

const SFC_VideoTourFloorPlanSetLoading_promise = (payload) => {
    return new Promise((resolve, reject) => {
        $("#SFC_VideoTour_FloorPlansSpinner").show("slow");
        $("#SFC_VideoTour_FloorPlans").hide("fast");
    });
};

const SFC_VideoTourFloorPlanClearLoading_promise = (payload) => {
    return new Promise((resolve, reject) => {
        $("#SFC_VideoTour_FloorPlans").show("slow");
        $("#SFC_VideoTour_FloorPlansSpinner").hide("fast");
    });
};

const SFC_RetrieveVideoTourFloorPlan_promise = (payload) => {
    return new Promise((resolve, reject) => {
        const { CommunityId } = payload;

        $.ajax({
            url: "url/" + CommunityId,
            method: "GET",
            success: function (data) {
                var responseJson = data;
                payload.Data = responseJson;
                resolve(payload);
            },
            error: function (error) {
                reject({
                    Message:
                        "CarouselRetrieveTimesDataByDate_promise: There was a problem retrieving information from the salesforce service\n",
                });
            },
        });
    });
};

const SFC_SetVideoTourFloorPlanData_promise = (payload) => {
    return new Promise((resolve, reject) => {
        if (payload != null && payload.Data != null) {
            const { Data } = payload;

            Data.forEach((dataPoint) => {
                $("#SFC_VideoTour_FloorPlans").append(
                    `<li><a href='${dataPoint.Url}'>${dataPoint.Text}</a></li>`
                );
            });
        }
    });
};

const SFC_ClearVideoTourFloorPlanData_promise = (payload) => {
    return new Promise((resolve, reject) => {
        $("#SFC_VideoTour_FloorPlans").empty();
        resolve(payload);
    });
};

const GenerateNewWeekContainer = (weekId) => {
    var weekContainer =
        "<div id=" + weekId + " class='CarouselWeekContainer'></div>";
    return weekContainer;
};

const GenerateNewDateCard = (date) => {
    let dayLabel = "";
    let dateDisplay = date.getDate();
    switch (date.getDay()) {
        case 0:
            dayLabel = "SU";
            break;
        case 1:
            dayLabel = "M";
            break;
        case 2:
            dayLabel = "T";
            break;
        case 3:
            dayLabel = "W";
            break;
        case 4:
            dayLabel = "TH";
            break;
        case 5:
            dayLabel = "F";
            break;
        case 6:
            dayLabel = "SA";
            break;
    }

    var fullDateValue =
        monthNames[date.getMonth()] +
        " " +
        date.getDate() +
        ", " +
        date.getFullYear();
    var dateValue =
        date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear(); //month + 1 because javascript is very smart and january == 0

    var dateCard =
        '<div id="DateCard' +
        dateDisplay +
        '" class="CarouselDateCard" data-date-display="' +
        fullDateValue +
        '" data-value="' +
        dateDisplay +
        '" data-date-payload="' +
        dateValue +
        '">' +
        '<div class="TopCard">' +
        '<div class="DayOfWeek">' +
        dayLabel +
        "</div>" +
        "</div>" +
        '<div class="BottomCard">' +
        '<div class="Date">' +
        dateDisplay +
        "</div>" +
        "</div>" +
        "</div>";
    dateCard = dateCard.trim();

    return dateCard;
};
//============================================= Entry Point End ========================================================//

//============================================= Initialize Modal Start
const InitializeSalesforceschedulerWizard = (payload) => {
    return InitializeDateCarousel(payload)
        .catch((err) => { })
        .finally(() => { });
};

const InitializeDateCarousel = (payload) => {
    return new Promise((resolve, reject) => {
        var carouselStartTime = new Date();
        carouselStartTime = new Date(
            carouselStartTime.getFullYear(),
            carouselStartTime.getMonth(),
            carouselStartTime.getDate()
        );
        const maxDisplay = 7;
        const maxWeeks = 4;
        $("#mth-book-a-tour").data("week", 0);

        var carouselDates = $("#WeekCalendarWrapper");
        var progressiveDate = new Date(carouselStartTime);
        var SameDayAppointment = null;
        for (var i = 0; i < maxWeeks; i++) {
            var carouselWeekID = "CarouselWeekContainer" + i;
            var week = GenerateNewWeekContainer(carouselWeekID);
            $(carouselDates).append(week);
            for (var j = 0; j < maxDisplay; j++) {
                var day = GenerateNewDateCard(progressiveDate);
                let cardID = "DateCard" + progressiveDate.getDate();
                if (i > 0 || $("#" + carouselWeekID).children().length > 0) {
                    $("#" + carouselWeekID).append(day);
                    $("#" + cardID).on("click", function () {
                        event.preventDefault();
                        $("#salesforce-tour-schedule-form-modal").data("same-day", "False");
                        if (!$(this).prop("disabled")) {
                            let thisCardVal = $(this).data("date-display");
                            let dateCardID = $(this).attr("id");
                            let dateCardValue = $(this).data("date-payload");
                            let previousID = $("#mth-book-a-tour").data("selected-card");
                            let previousSelections = $("#DateCard" + previousID);
                            let currentCard = $("#" + dateCardID);
                            const externalID = $("#salesforce-tour-schedule-form-modal").data(
                                "external-id"
                            );

                            var payload = {
                                CardValue: thisCardVal,
                                CardID: dateCardID,
                                CardDateValue: dateCardValue,
                                PreviousID: previousID,
                                PreviousSelection: previousSelections,
                                CurrentCard: currentCard,
                                CommunityExternalId: externalID,
                            };

                            var AppointmentOnly =
                                $("#salesforce-tour-schedule-form-modal").data(
                                    "appointment-only"
                                ) == "True"
                                    ? true
                                    : false;
                            if (!AppointmentOnly) {
                                //$("#SFC_TourSchedulePageBtn").removeClass("hide");
                                CarouselDateClick_action(payload);
                            } else CarouselDateClickBypassRetrieval_action(payload);
                        }
                    });
                } else {
                    $("#" + carouselWeekID).append(day);
                    $("#" + cardID).on("click", function () {
                        if (
                            $("#salesforce-tour-schedule-form-modal").data("same-day") ==
                            "False"
                        ) {
                            $("#salesforce-tour-schedule-form-modal").data(
                                "same-day",
                                "True"
                            );
                        } else $("#salesforce-tour-schedule-form-modal").data("same-day", "True");

                        $("#GuidedTourTimes").empty();
                        var thisCardVal = $(this).data("date-display");
                        var dateCardID = $(this).attr("id");
                        var dateCardValue = $(this).data("date-payload");
                        var previousID = $("#mth-book-a-tour").data("selected-card");
                        if (previousID != null && previousID != null) {
                            $("#" + previousID).removeClass("CarouselDateCard--selected");
                            $("#" + previousID).addClass("CarouselDateCard");
                        }

                        if ($(this).hasClass("CarouselDateCard--selected")) {
                            $(this).addClass("CarouselDateCard");
                            $(this).removeClass("CarouselDateCard--selected");
                        } else {
                            $(this).addClass("CarouselDateCard--selected");
                            $(this).removeClass("CarouselDateCard");
                        }

                        $("#mth-book-a-tour").data("selected-card", dateCardID);
                        $("#mth-book-a-tour").data("selected-date", dateCardValue);
                        $("#CarouselSelectedDate").text(thisCardVal);
                    });
                }
                progressiveDate.setDate(progressiveDate.getDate() + 1);
            }
        }

        var slider = tns({
            container: "#mth-book-a-tour .my-slider",
            items: 4,
            slideBy: "page",
            autoplay: false,
            loop: false,
            controlsContainer: "#mth-book-a-tour .tour-schedule-date-slider-controls",
            responsive: {
                0: {
                    items: 1,
                    gutter: 10,
                },

                640: {
                    items: 1,
                    gutter: 10,
                },

                768: {
                    items: 1,
                    gutter: 10,
                },
                1024: {
                    items: 1,
                    gutter: 10,
                },
                1200: {
                    items: 1,
                    gutter: 10,
                },
                1440: {
                    items: 1,
                    gutter: 10,
                },
            },
        });

        $("#salesforce-tour-schedule-form-modal").unbind("closed.zf.reveal");
        $("#salesforce-tour-schedule-form-modal").on(
            "closed.zf.reveal",
            function () {
                $("#" + workflow.currentStepKey).addClass("scheduler-page-hidden");
                $("#" + workflow.currentStepKey).removeClass("scheduler-page-visible");

                ResetUIControls();

                /*CleanupDataAttributes();
                    SalesforceSchedulerClearErrors();
                    RemoveFormLiveValidation();
                    $("#salesforce-tour-schedule-form-modal").data("same-day", "False");
                    $("#BookYourTourNow").prop("disabled", true);
        
                    $(document).unbind("click", "#mth-book-a-tour .slider-controls-button");
                    $(document).unbind("CarouselSetActiveSlider");
                    slider.destroy();*/
            }
        );

        $(document).bind("CarouselSetActiveSlider", function (e, index) {
            slider.goTo(index);
            var sliderInfo = slider.getInfo();
            if (sliderInfo.displayIndex == 1) {
                if (!$("#mth-book-a-tour .prev").hasClass("hide")) {
                    $("#mth-book-a-tour .prev").addClass("hide");
                }
                while ($("#mth-book-a-tour .next").hasClass("hide")) {
                    $("#mth-book-a-tour .next").removeClass("hide");
                }
            }

            if (sliderInfo.displayIndex > 1 && sliderInfo.displayIndex < 4) {
                while ($("#mth-book-a-tour .next").hasClass("hide")) {
                    $("#mth-book-a-tour .next").removeClass("hide");
                }
                while ($("#mth-book-a-tour .prev").hasClass("hide")) {
                    $("#mth-book-a-tour .prev").removeClass("hide");
                }
            }
            if (index == 4) {
                if (!$("#mth-book-a-tour .next").hasClass("hide")) {
                    $("#mth-book-a-tour .next").addClass("hide");
                }

                while ($("#mth-book-a-tour .prev").hasClass("hide")) {
                    $("#mth-book-a-tour .prev").removeClass("hide");
                }
            }
        });
        $(document).unbind("click", "#mth-book-a-tour .slider-controls-button");
        $(document).on(
            "click",
            "#mth-book-a-tour .slider-controls-button",
            function () {
                var sliderInfo = slider.getInfo();

                if (sliderInfo.displayIndex == 1) {
                    while (!$("#mth-book-a-tour .prev").hasClass("hide")) {
                        $("#mth-book-a-tour .prev").addClass("hide");
                    }
                }

                if (sliderInfo.displayIndex > 1 && sliderInfo.displayIndex < 4) {
                    while ($("#mth-book-a-tour .prev").hasClass("hide")) {
                        $("#mth-book-a-tour .prev").removeClass("hide");
                    }
                    while ($("#mth-book-a-tour .next").hasClass("hide")) {
                        $("#mth-book-a-tour .next").removeClass("hide");
                    }
                }

                if (sliderInfo.displayIndex == 4) {
                    if (!$("#mth-book-a-tour .next").hasClass("hide")) {
                        $("#mth-book-a-tour .next").addClass("hide");
                    }
                }
                $(this).data("week", sliderInfo.displayIndex - 1);
            }
        );

        resolve(payload);
    });
};

function InitializeModalEvents(payload) {
    return new Promise((resolve, reject) => {
        var carouselStartTime = new Date();
        carouselStartTime = new Date(
            carouselStartTime.getFullYear(),
            carouselStartTime.getMonth(),
            carouselStartTime.getDate()
        );
        const maxDisplay = 7;
        const maxWeeks = 4;
        $("#mth-book-a-tour").data("week", 0);

        var carouselDates = $("#WeekCalendarWrapper");
        var progressiveDate = new Date(carouselStartTime);
        var SameDayAppointment = null;
        for (var i = 0; i < maxWeeks; i++) {
            var carouselWeekID = "CarouselWeekContainer" + i;
            var week = GenerateNewWeekContainer(carouselWeekID);
            $(carouselDates).append(week);
            for (var j = 0; j < maxDisplay; j++) {
                var day = GenerateNewDateCard(progressiveDate);
                let cardID = "DateCard" + progressiveDate.getDate();
                if (i > 0 || $("#" + carouselWeekID).children().length > 0) {
                    $("#" + carouselWeekID).append(day);
                    //$("#" + cardID).on("click", function () {
                    //    event.preventDefault();
                    //    $("#salesforce-tour-schedule-form-modal").data("same-day", "False");
                    //    if (!$(this).prop("disabled")) {
                    //        let thisCardVal = $(this).data("date-display");
                    //        let dateCardID = $(this).attr("id");
                    //        let dateCardValue = $(this).data("date-payload");
                    //        let previousID = $("#mth-book-a-tour").data("selected-card");
                    //        let previousSelections = $("#DateCard" + previousID);
                    //        let currentCard = $("#" + dateCardID);
                    //        const externalID = $("#salesforce-tour-schedule-form-modal").data("external-id");

                    //        var payload = {
                    //            CardValue: thisCardVal,
                    //            CardID: dateCardID,
                    //            CardDateValue = dateCardValue,
                    //            PreviousID = previousID,
                    //            PreviousSelection = previousSelections,
                    //            CurrentCard = currentCard,
                    //            CommunityExternalId: externalID
                    //        }

                    //        var AppointmentOnly = ($("#salesforce-tour-schedule-form-modal").data("appointment-only") == "True") ? true : false;
                    //        if (!AppointmentOnly)
                    //            CarouselDateClick_action(payload);
                    //        else
                    //            CarouselDateClickBypassRetrieval_action(payload);
                    //    }

                    //});
                } else {
                    $("#" + carouselWeekID).append(day);
                }
                progressiveDate.setDate(progressiveDate.getDate() + 1);
            }
        }

        var slider = tns({
            container: "#mth-book-a-tour .my-slider",
            items: 4,
            slideBy: "page",
            autoplay: false,
            loop: false,
            controlsContainer: "#mth-book-a-tour .tour-schedule-date-slider-controls",
            responsive: {
                0: {
                    items: 1,
                    gutter: 10,
                },

                640: {
                    items: 1,
                    gutter: 10,
                },

                768: {
                    items: 1,
                    gutter: 10,
                },
                1024: {
                    items: 1,
                    gutter: 10,
                },
                1200: {
                    items: 1,
                    gutter: 10,
                },
                1440: {
                    items: 1,
                    gutter: 10,
                },
            },
        });

        $("#salesforce-tour-schedule-form-modal").unbind("closed.zf.reveal");
        $("#salesforce-tour-schedule-form-modal").on(
            "closed.zf.reveal",
            function () {
                //$("#salesforce-tour-schedule-form-modal").unbind("closed.zf.reveal");
                //$("#salesforce-tour-schedule-form-modal").on('closed.zf.reveal', function () {
                //    var modal = $(this);
                //    CleanupDataAttributes();
                //    SalesforceSchedulerClearErrors();
                //    RemoveFormLiveValidation();
                //    $("#salesforce-tour-schedule-form-modal").data("same-day", "False");
                //    $("#BookYourTourNow").prop("disabled", true);
                //    //$(document).unbind("click", "#mth-book-a-tour .slider-controls-button");
                //    //$(document).unbind("CarouselSetActiveSlider");
                //    //slider.destroy();

                $(document).unbind("CarouselSetActiveSlider");
                $(document).bind("CarouselSetActiveSlider", function (e, index) {
                    slider.goTo(index);
                    var sliderInfo = slider.getInfo();
                    if (sliderInfo.displayIndex == 1) {
                        if (!$("#mth-book-a-tour .prev").hasClass("hide")) {
                            $("#mth-book-a-tour .prev").addClass("hide");
                        }
                        while ($("#mth-book-a-tour .next").hasClass("hide")) {
                            $("#mth-book-a-tour .next").removeClass("hide");
                        }
                    }

                    if (sliderInfo.displayIndex > 1 && sliderInfo.displayIndex < 4) {
                        while ($("#mth-book-a-tour .next").hasClass("hide")) {
                            $("#mth-book-a-tour .next").removeClass("hide");
                        }
                        while ($("#mth-book-a-tour .prev").hasClass("hide")) {
                            $("#mth-book-a-tour .prev").removeClass("hide");
                        }
                    }
                    if (index == 4) {
                        if (!$("#mth-book-a-tour .next").hasClass("hide")) {
                            $("#mth-book-a-tour .next").addClass("hide");
                        }

                        while ($("#mth-book-a-tour .prev").hasClass("hide")) {
                            $("#mth-book-a-tour .prev").removeClass("hide");
                        }
                    }
                });

                $(document).unbind("click", "#mth-book-a-tour .slider-controls-button");
                $(document).on(
                    "click",
                    "#mth-book-a-tour .slider-controls-button",
                    function () {
                        var sliderInfo = slider.getInfo();

                        if (sliderInfo.displayIndex == 1) {
                            while (!$("#mth-book-a-tour .prev").hasClass("hide")) {
                                $("#mth-book-a-tour .prev").addClass("hide");
                            }
                        }

                        if (sliderInfo.displayIndex > 1 && sliderInfo.displayIndex < 4) {
                            while ($("#mth-book-a-tour .prev").hasClass("hide")) {
                                $("#mth-book-a-tour .prev").removeClass("hide");
                            }
                            while ($("#mth-book-a-tour .next").hasClass("hide")) {
                                $("#mth-book-a-tour .next").removeClass("hide");
                            }
                        }

                        if (sliderInfo.displayIndex == 4) {
                            if (!$("#mth-book-a-tour .next").hasClass("hide")) {
                                $("#mth-book-a-tour .next").addClass("hide");
                            }
                        }
                        $(this).data("week", sliderInfo.displayIndex - 1);
                    }
                );

                //document.getElementById('BookATourPhone').addEventListener('input', function (e) {
                //    var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                //    e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
                //});

                //$("#ErrorButton").unbind("click");
                //$("#ErrorButton").on("click", function (event) {
                //    event.preventDefault();
                //    SubmitGuidedTourBookingError_action();
                //});
                //$("#SuccessButton").unbind("click");
                //$("#SuccessButton").on("click", function (event) {
                //    event.preventDefault();
                //    SubmitGuidedTourBookingSuccess_action();
                //});

                resolve(payload);
            }
        );
    });
}

/************************************************************************************
 *************************** Salesforcescheduler Carousel ***************************
 ***********************************************************************************/

function CarouselDisable_promise(payload) {
    return new Promise((resolve, reject) => {
        $("#mth-book-a-tour").prop("disabled", true);

        $("#mth-carousel-prev-slider").prop("disabled", true);
        $("#mth-carousel-next-slider").prop("disabled", true);

        $("#WeekCalendarWrapper")
            .children()
            .each(function () {
                $(this).prop("disabled", true);
                $(this)
                    .children()
                    .each(function () {
                        $(this).prop("disabled", true);
                    });
            });
        resolve(payload);
    });
}

function CarouselSetSelection_promise(payload) {
    return new Promise((resolve, reject) => {
        if (!$(payload.CurrentCard).hasClass("CarouselDateCard--selected"))
            $(payload.CurrentCard).addClass("CarouselDateCard--selected");
        if ($(payload.CurrentCard).hasClass("CarouselDateCard"))
            $(payload.CurrentCard).removeClass("CarouselDateCard");

        $("#mth-book-a-tour").data("selected-card", payload.CardID);
        $("#mth-book-a-tour").data("selected-date", payload.CardDateValue);
        $("#CarouselSelectedDate").text(payload.CardValue);
        resolve(payload);
    });
}

function CarouselSetTimesLoading_promise(payload) {
    return new Promise((resolve, reject) => {
        var guidedTourTimes = $("#GuidedTourTimes");
        if (guidedTourTimes == null) {
            reject({
                Message:
                    "CarouselSetTimesLoading_promise: Could not find GuidedTourTimes",
            });
        } else {
            $(guidedTourTimes).hide("fast", function () {
                $("#GuidedTourTimesSpinner").show("fast", function () {
                    resolve(payload);
                });
            });
        }
    });
}

function CarouselClearTimesData_promise(payload) {
    return new Promise((resolve, reject) => {
        $("#GuidedTourTimes").empty();
        resolve(payload);
    });
}

function CarouselRetrieveTimesDataByDate_promise(payload) {
    return new Promise((resolve, reject) => {
        const bookingDateTime = payload.CardDateValue;
        const communityNumber = payload.CommunityExternalId;
        const salesforceServiceUrl = $("#salesforce-tour-schedule-form-modal").data(
            "salesforce-service-url"
        );

        //console.log("CarouselRetrieveTimesDataByDate_promise");
        //console.log(bookingDateTime);
        //console.log(communityNumber);
        //console.log(salesforceServiceUrl);
        $.ajax({
            url:
                salesforceServiceUrl +
                "/api/Salesforce/GetBookingDayData/" +
                encodeURIComponent(bookingDateTime) +
                "/" +
                communityNumber,
            method: "GET",
            success: function (data) {
                var responseJson = data;
                payload.Data = responseJson;
                resolve(payload);
            },
            error: function (error) {
                reject({
                    Message:
                        "CarouselRetrieveTimesDataByDate_promise: There was a problem retrieving information from the salesforce service\n",
                });
            },
        });
    });
}

function CarouselSimulateRetrieveTimesDataByDate_promise(payload) {
    return new Promise((resolve, reject) => {
        const salesforceServiceUrl = $("#salesforce-tour-schedule-form-modal").data(
            "salesforce-service-url"
        );

        $("#salesforce-tour-schedule-form-modal").data("external-id", "8685");
        $("#mth-book-a-tour").data("selected-date", "07/29/2022");
        const bookingDateTime = $("#mth-book-a-tour").data("selected-date");
        const communityNumber = $("#salesforce-tour-schedule-form-modal").data(
            "external-id"
        );

        //console.log("CarouselRetrieveTimesDataByDate_promise");
        //console.log(bookingDateTime);
        //console.log(communityNumber);
        //console.log(salesforceServiceUrl);

        $.ajax({
            url:
                salesforceServiceUrl +
                "/api/Salesforce/GetBookingDayData/" +
                encodeURIComponent(bookingDateTime) +
                "/" +
                communityNumber,
            method: "GET",
            success: function (data) {
                var responseJson = data;
                payload.Data = responseJson;
                resolve(payload);
            },
            error: function (error) {
                reject({
                    Message:
                        "CarouselSimulateRetrieveTimesDataByDate_promise: There was a problem retrieving information from the salesforce service\n",
                });
            },
        });
    });
}

function CarouselSetTimesData_promise(payload) {
    return new Promise((resolve, reject) => {
        var timeArray = payload.Data.availableSlots;

        var sortedArray = _.sortBy(timeArray, "startHour");

        $("#GuidedTourTimes").empty();
        if (
            sortedArray == null ||
            (Array.isArray(sortedArray) && sortedArray.length == 0)
        ) {
            $("#GuidedTourTimes").append(
                "<label style='font-size:18px;font-weight:bold'>We're sorry, but there are no available times for this date. Please choose another date.<label>"
            );
        } else {
            sortedArray.forEach((slot) => {
                //console.log("CarouselSetTimesData_promise");
                var startHour = slot.startHour;

                let fullDateValueTime = payload.CardValue;
                let displayValue = null;
                if (startHour == 0 || startHour == 24) {
                    fullDateValueTime = fullDateValueTime + " 12:00 am";
                    displayValue = "12:00 am";
                } else if (startHour < 12 && startHour > 0) {
                    fullDateValueTime = fullDateValueTime + " " + startHour + ":00 am";
                    displayValue = startHour + ":00 am";
                } else if (startHour >= 12 && startHour < 24) {
                    fullDateValueTime =
                        fullDateValueTime +
                        " " +
                        (startHour - 12 > 0 ? startHour - 12 : 12) +
                        ":00 pm";
                    displayValue = (startHour - 12 > 0 ? startHour - 12 : 12) + ":00 pm";
                } else {
                    fullDateValueTime = "INVALID";
                    displayValue = "INVALID";
                }

                var TimeSlotPayload = {
                    ID: "TimeSlot" + startHour,
                    DisplayValue: displayValue,
                    FullDate: fullDateValueTime,
                    TimeValue: startHour,
                    DatePayload: payload.CardDateValue,
                };

                //console.log(TimeSlotPayload);

                //console.log("generated timeslot");
                //console.log(TimeSlotPayload)

                var generatedTimeSlot =
                    SalesforceSchedulerGenerateTimeSlot(TimeSlotPayload);
                $("#GuidedTourTimes").append(generatedTimeSlot);
                $("#" + TimeSlotPayload.ID).on(
                    "click",
                    SalesforceTourSchedulerTimeClick
                );
            });
        }

        resolve(payload);
        //}
    });
}

function CarouselEnable_promise(payload) {
    return new Promise((resolve, reject) => {
        $("#mth-book-a-tour").prop("disabled", false);

        $("#mth-carousel-prev-slider").prop("disabled", false);
        $("#mth-carousel-next-slider").prop("disabled", false);

        $("#WeekCalendarWrapper")
            .children()
            .each(function () {
                $(this).prop("disabled", false);
                $(this)
                    .children()
                    .each(function () {
                        $(this).prop("disabled", false);
                    });
            });

        resolve(payload);
    });
}

function CarouselDateClick_action(payload) {
    return CarouselDisable_promise(payload)
        .then(CarouselSetTimesLoading_promise)
        .then(CarouselClearTimesData_promise)
        .then(CarouselSetSelection_promise)
        .then(CarouselRetrieveTimesDataByDate_promise)
        .then(CarouselSetTimesData_promise)
        .catch((error) => {
            console.log("CarouselDateClick_action: " + error.Message);
        })
        .finally((fin) =>
            CarouselClearTimesLoading_promise().then(CarouselEnable_promise)
        );
}

function CarouselSimulateDateClick_action() {
    return CarouselSetTimesLoading_promise({})
        .then(CarouselClearTimesData_promise)
        .then(CarouselSimulateRetrieveTimesDataByDate_promise)
        .then(CarouselSetTimesData_promise)
        .catch((error) => {
            console.log("CarouselDateClick_action: " + error.Message);
        })
        .finally((fin) => CarouselClearTimesLoading_promise());
}

/************************************************************************************
 *************************** Salesforcescheduler Carousel ***************************
 ***********************************************************************************/

function SalesforceSchedulerGenerateTimeSlot(payload) {
    const { ID, DisplayValue, FullDate, DatePayload, TimeValue } = payload;
    var timeSlot =
        "<div id='" +
        ID +
        "' class='TimeSlot' data-time-slot-date='" +
        FullDate +
        "'" +
        "data-time-value='" +
        ID +
        "' data-date-payload='" +
        DatePayload +
        "' data-hours-value='" +
        TimeValue +
        "' > " +
        DisplayValue +
        "</div > ";
    return timeSlot;
}

function CarouselClearTimesLoading_promise(payload) {
    return new Promise((resolve, reject) => {
        $("#GuidedTourTimesSpinner").hide("fast", function () {
            $("#GuidedTourTimes").show("fast", function () {
                resolve(payload);
            });
        });
    });
}

const InitializeRegisterPage = () => {
    $("#SFC_HomebuyerCheckbox").on("click", function () {
        if ($(this).is(":checked")) {
            $("#SFC_HomebuyerForm").show("slow");
            $(this).val("true");
        } else {
            $("#SFC_HomebuyerForm").hide("fast");
            $(this).val("false");
        }
    });

    $("#SFC_AgentCheckbox").on("click", function () {
        if ($(this).is(":checked")) {
            $("#SFC_AgentForm").show("slow");
            $(this).val("true");
        } else {
            $("#SFC_AgentForm").hide("fast");
            $(this).val("false");
        }
    });

    //$("#SFC_SimulateGetAPICall").on("click", function () {
    //    event.preventDefault();
    //    CarouselSimulateDateClick_action();
    //});

    $("#HomebuyerMobilePhoneNumber").unbind("input");
    $("#HomebuyerMobilePhoneNumber").on("input", function (e) {
        var x = e.target.value
            .replace(/\D/g, "")
            .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        if (x == null || !Array.isArray(x)) e.target.value = null;
        else
            e.target.value = !x[2]
                ? x[1]
                : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
    });

    $("#AgentMobilePhoneNumber").unbind("input");
    $("#AgentMobilePhoneNumber").on("input", function (e) {
        var x = e.target.value
            .replace(/\D/g, "")
            .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        if (x == null || !Array.isArray(x)) e.target.value = null;
        else
            e.target.value = !x[2]
                ? x[1]
                : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
    });

    $("#AgentZipcode").unbind("input");
    $("#AgentZipcode").on("input", function (e) {
        var x = e.target.value.replace(/\D/g, "").match(/(\d{0,5})(\d{0,4})/);
        e.target.value = !x[2] ? x[1] : x[1] + "-" + x[2];
        if (x == null || !Array.isArray(x)) e.target.value = null;
        else e.target.value = x[0];
    });

    $("#HomebuyerFirstName").unbind("input");
    $("#HomebuyerFirstName").on("input", function (e) {
        var x = e.target.value.replace(/[0-9]/g, "").match(/(\D{1,49})/);
        if (x == null || !Array.isArray(x)) e.target.value = null;
        else e.target.value = x[0];
    });

    $("#HomebuyerLastName").unbind("input");
    $("#HomebuyerLastName").on("input", function (e) {
        var x = e.target.value.replace(/[0-9]/g, "").match(/(\D{1,49})/);
        if (x == null || !Array.isArray(x)) e.target.value = null;
        else e.target.value = x[0];
    });

    $("#AgentFirstName").unbind("input");
    $("#AgentFirstName").on("input", function (e) {
        var x = e.target.value.replace(/[0-9]/g, "").match(/(\D{1,49})/);
        if (x == null || !Array.isArray(x)) e.target.value = null;
        else e.target.value = x[0];
    });

    $("#AgentLastName").unbind("input");
    $("#AgentLastName").on("input", function (e) {
        var x = e.target.value.replace(/[0-9]/g, "").match(/(\D{1,49})/);
        if (x == null || !Array.isArray(x)) e.target.value = null;
        else e.target.value = x[0];
    });
};

function InitializeWebForm() {
    $("#SFC_TourRegistrationPage_forms").submit(function (e) {
        e.preventDefault();

        var $form = $(this);
        var generatedPayloadData = generateFullPostPayload();
        console.log("SFC_TourRegistrationPage_forms");
        console.log(generatedPayloadData);
        console.log("Trying to submit data over to api");
        $.ajax({
            url: "/api/sitecore/SalesforceTourScheduler",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(generatedPayloadData),
            method: "POST",
            success: function (data) {
                console.log("Successfully posted to api endpoint");
                console.log(data);
            },
            error: function (data) {
                console.log("ERROR posted to api endpoint");
                console.log(data);
            },
            complete: function (data) {
                console.log("Success submitting data to endpoint");
                console.log(data);
                if (data.status === 200) {
                    if (data.responseJSON.success) {
                        $("#SFC_TourRegistrationPage").hide();
                        $("#SFC_RequestTourThankYouPage").show();
                    } else if (data.responseJSON.anchorRedirect != null) {
                        window.location.replace(
                            window.location.href + data.responseJSON.urlRedirect
                        );
                        console.log("Response Error submitting to API");
                    } else if (data.responseJSON.errorRecaptchaValidation) {
                        $("#SFC_TourRegistrationPage").hide();
                        $("#SFC_RequestTourErrorPage").show();
                        console.log("Captcha Error submitting to API");
                    }
                } else {
                    $("#SFC_TourRegistrationPage").hide();
                    $("#SFC_RequestTourErrorPage").show();
                    console.log("Generic ErrorError submitting to API");
                }
            },
        });
    });
}

/************************************************************************************
 ********************** Salesforcescheduler Register Page ***************************
 ************************************************************************************
 */

const RegisterPageSubmit_action = () => {
    var agentCheckBox = $("#SFC_AgentCheckbox").is(":checked");
    var homeBuyerCheckBox = $("#SFC_HomebuyerCheckbox").is(":checked");

    //console.log("RegisterPageSubmit_action:");
    //console.log("agentCheckBox:" + agentCheckBox);
    //console.log("homeBuyerCheckBox:" + homeBuyerCheckBox);
    $("#VisitorCheckboxError").hide("fast");

    if (agentCheckBox && homeBuyerCheckBox) {
        //console.log("RegisterPageAgentAndHomebuyerSubmit_action");
        return RegisterPageAgentAndHomebuyerSubmit_action();
    } else if (agentCheckBox) {
        //console.log("RegisterPageAgentSubmit_action");
        return RegisterPageAgentSubmit_action();
    } else if (homeBuyerCheckBox) {
        //console.log("RegisterPageHomebuyerSubmit_action");
        return RegisterPageHomebuyerSubmit_action();
    } else {
        $("#VisitorCheckboxError").show("slow");
    }
};

const SubmitTourRequestForm_action = () => {
    console.log("SubmitTourRequestForm_action trigger");
    $("#SFC_TourRegistrationPage_forms").submit();
};

const RegisterPageAgentSubmit_action = () => {
    return (
        RegisterPageSetLoading_promise()
            .then(RegisterPageGenerateCommonPayload_promise)
            .then(RegisterPageValidateCommonData_promise)
            .then(RegisterPageGenerateAgentPayload_promise)
            .then(RegisterPageAgentValidate_promise)
            .then(RegisterPageGenerateAgentRegistrationPayload_promise)
            .then(SubmitTourRequestForm_action)
            //.then(RegisterPageSubmitAgentRegistrationForm_promise)
            //.then(RegisterPageSubmitAgentRequest_promise)
            .catch((Error) => {
                const { ErrorCode, ErrorSource, ErrorMessage } = Error;

                console.log(
                    `${ErrorSource} Generated the following error: ${ErrorMessage}`
                );
            })
            .finally(() => RegisterPageClearLoading_promise())
    );
};

const RegisterPageHomebuyerSubmit_action = () => {
    return (
        RegisterPageSetLoading_promise()
            .then(RegisterPageGenerateCommonPayload_promise)
            .then(RegisterPageValidateCommonData_promise)
            .then(RegisterPageHomebuyerGeneratePayload_promise)
            .then(RegisterPageHomebuyerValidate_promise)
            .then(SubmitTourRequestForm_action)
            //.then(RegisterPageHomebuyerSubmitRequest_promise)
            .catch((Error) => {
                const { ErrorCode, ErrorSource, ErrorMessage } = Error;
                //console.log(Error);
                console.log(
                    `${ErrorSource} Generated the following error: ${ErrorMessage}`
                );
            })
            .finally(() => RegisterPageClearLoading_promise())
    );
};

const RegisterPageAgentAndHomebuyerSubmit_action = () => {
    return (
        RegisterPageSetLoading_promise()
            .then(RegisterPageGenerateCommonPayload_promise)
            .then(RegisterPageValidateCommonData_promise)
            .then(RegisterPageHomebuyerGeneratePayload_promise)
            .then(RegisterPageHomebuyerValidate_promise)
            .then(RegisterPageGenerateAgentPayload_promise)
            .then(RegisterPageAgentValidate_promise)
            .then(RegisterPageGenerateAgentRegistrationPayload_promise)
            .then(SubmitTourRequestForm_action)
            //.then(RegisterPageSubmitAgentRegistrationForm_promise)
            //.then(RegisterPageSubmitAgentRequest_promise)
            .catch((Error) => {
                const { ErrorCode, ErrorSource, ErrorMessage } = Error;

                console.log(
                    `${ErrorSource} Generated the following error: ${ErrorMessage}`
                );
            })
            .finally(() => {
                return RegisterPageClearLoading_promise();
            })
    );
};

const RegisterPageGenerateCommonPayload_promise = (payload = {}) => {
    return new Promise((resolve, reject) => {
        //$("#salesforce-tour-schedule-form-modal").data("external-id", "8685");
        //$("#mth-book-a-tour").data("selected-date", "07/29/2022");
        console.log("RegisterPageGenerateCommonPayload_promise");
        var TourAddress = $("#TourAddress").val();
        var PreferredDateTime = $("#PreferredDatetimeInput").val();
        var CommunityID = $("#salesforce-tour-schedule-form-modal").data(
            "external-id"
        );
        var BookingDate = $("#mth-book-a-tour").data("selected-date");
        var BookingHour = $("#mth-book-a-tour").data("selected-date-time-value");
        var AppointmentType = $("#virtually").prop("checked")
            ? __virtualTour
            : __inPersonTour;
        var GaClientID = $("#salesforceTourSchedulerGAClientId").val();
        var PagePath = $("#salesforceTourSchedulerPagePath").val();
        var Origin = __origin;
        var ContactType = __contactType;
        var PrimaryLeadSource = __primaryLeadSource;
        var LeadSource = __leadSource;
        var SubSource = __subSource;
        var LeadSubSource = $('input[name="LeadSubSource"]').val();
        var Notes =
            TourAddress +
            "/" +
            PreferredDateTime +
            "/" +
            $("#BookATourNotes").val() +
            "/Requested by " +
            LeadSubSource;
        var EmailOptIn = $("#EmailOptInId").val();
        var SmsOptIn = $("#SMSOptInId").val();

        payload["CommonInfo"] = {
            TourAddress: TourAddress,
            PreferredDateTime: PreferredDateTime,
            CommunityId: CommunityID,
            BookingDate: BookingDate,
            BookingHour: BookingHour,
            AppointmentType: AppointmentType,
            Notes: Notes,
            GaClientID: GaClientID,
            PagePath: PagePath,
            Origin: Origin,
            ContactType: ContactType,
            PrimaryLeadSource: PrimaryLeadSource,
            LeadSource: LeadSource,
            SubSource: SubSource,
            LeadSubSource: LeadSubSource,
            SmsOptIn: SmsOptIn,
            EmailOptIn: EmailOptIn,
        };
        //console.log("RegisterPageGenerateCommonPayload_promise");
        //console.log(payload);
        resolve(payload);
    });
};

const RegisterPageValidateCommonDataNoTour_promise = (payload) => {
    return new Promise((resolve, reject) => {
        const { CommonInfo } = payload;

        //console.log(CommonInfo);

        var valid = true;
        let errorMessage = "";

        var ErrorPayload = {
            ErrorCode: "",
            ErrorSource: "RegisterPageValidateCommonDataNoTour_promise",
            ErrorMessage: "",
        };

        const {
            CommunityId,
            BookingDate,
            BookingHour,
            AppointmentType,
            Notes,
            GaClientID,
            PagePath,
            Origin,
            ContactType,
            LeadSource,
            SubSource,
            SmsOptIn,
            EmailOptIn,
        } = CommonInfo;

        if (CommunityId == null || CommunityId == "") {
            valid = false;
            errorMessage = errorMessage.concat("Error validating CommunityId.\n");
        }
        if (AppointmentType == null || AppointmentType == "") {
            //console.log("AppointmentType");
            valid = false;
            errorMessage = errorMessage.concat("Error validating AppointmentType.\n");
        }
        //if (GaClientID == null || GaClientID == "") {
        //    valid = false;
        //    errorMessage = errorMessage.concat("Error validating GaClientID.\n");
        //}
        if (PagePath == null || PagePath == "") {
            //console.log("PagePath");
            valid = false;
            errorMessage = errorMessage.concat(
                "Error validating PagePathPagePath.\n"
            );
        }
        if (Origin == null || Origin == "") {
            //console.log("Origin");
            valid = false;
            errorMessage = errorMessage.concat("Error validating Origin.\n");
        }
        if (ContactType == null || ContactType == "") {
            //console.log("ContactType");
            valid = false;
            errorMessage = errorMessage.concat("Error validating ContactType.\n");
        }
        if (LeadSource == null || LeadSource == "") {
            //console.log("LeadSource");
            valid = false;
            errorMessage = errorMessage.concat("Error validating AppointmentType.\n");
        }
        if (SubSource == null || SubSource == "") {
            //console.log("SubSource");
            valid = false;
            errorMessage = errorMessage.concat("Error validating SubSource.\n");
        }

        //console.log("errorMessage " + errorMessage);
        //console.log(errorMessage.length);
        //console.log(valid);
        if (errorMessage.length > 0 || !valid) {
            //console.log(valid);
            //console.log("RegisterPageValidateCommonDataNoTour_promise");
            //console.log(payload);
            reject(ErrorPayload);
        } else {
            //console.log(valid);
            resolve(payload);
        }
    });
};

const RegisterPageValidateCommonData_promise = (payload) => {
    return new Promise((resolve, reject) => {
        const { CommonInfo } = payload;

        console.log("RegisterPageValidateCommonData_promise");

        //console.log(CommonInfo);

        var valid = true;
        let errorMessage = "";

        var ErrorPayload = {
            ErrorCode: "",
            ErrorSource: "RegisterPageValidateCommonData_promise",
            ErrorMessage: "",
        };

        const {
            TourAddress,
            PreferredDateTime,
            CommunityId,
            BookingDate,
            BookingHour,
            AppointmentType,
            Notes,
            GaClientID,
            PagePath,
            Origin,
            ContactType,
            PrimaryLeadSource,
            LeadSource,
            SubSource,
            LeadSubSource,
            SmsOptIn,
            EmailOptIn,
        } = CommonInfo;

        if (TourAddress == null || TourAddress == "") {
            valid = false;
            errorMessage = errorMessage.concat(
                "Tour Address can't be null or empty.\n"
            );
            $("#TourAddressError").show("slow");
        } else $("#TourAddressError").hide("fast");

        if (PreferredDateTime == null || PreferredDateTime == "") {
            valid = false;
            errorMessage = errorMessage.concat(
                "Preferred Date & Time haven't been selected.\n"
            );
            $("#PreferredDateTimeError").show("slow");
        } else {
            var dt = new Date(PreferredDateTime);
            if (dt <= Date.now()) {
                valid = false;
                errorMessage = errorMessage.concat(
                    "Preferred Date & Time can't be in past.\n"
                );
                $("#PreferredDateTimeError").show("slow");
            } else {
                $("#PreferredDateTimeError").hide("fast");
            }
        }

        if (
            !$("#SFC_HomebuyerCheckbox").prop("checked") &&
            !$("#SFC_AgentCheckbox").prop("checked")
        ) {
            valid = false;
            errorMessage = errorMessage.concat(
                "Either Home Buyer or Agent or both must be checked for cominig to the tour.\n"
            );
            $("#VisitorCheckboxError").show("slow");
        } else $("#VisitorCheckboxError").hide("fast");

        if (AppointmentType == null || AppointmentType == "") {
            valid = false;
            errorMessage = errorMessage.concat("Error validating AppointmentType.\n");
        }

        if (PagePath == null || PagePath == "") {
            valid = false;
            errorMessage = errorMessage.concat(
                "Error validating PagePathPagePath.\n"
            );
        }
        if (Origin == null || Origin == "") {
            valid = false;
            errorMessage = errorMessage.concat("Error validating Origin.\n");
        }
        if (ContactType == null || ContactType == "") {
            valid = false;
            errorMessage = errorMessage.concat("Error validating ContactType.\n");
        }
        if (LeadSource == null || LeadSource == "") {
            valid = false;
            errorMessage = errorMessage.concat("Error validating AppointmentType.\n");
        }
        if (SubSource == null || SubSource == "") {
            valid = false;
            errorMessage = errorMessage.concat("Error validating SubSource.\n");
        }

        if (errorMessage.length > 0 || !valid) {
            reject(ErrorPayload);
        } else {
            resolve(payload);
        }
    });
};

const RegisterPageValidateDuringBusinessHoursCommonData_promise = (payload) => {
    return new Promise((resolve, reject) => {
        const { CommonInfo } = payload;

        //console.log(CommonInfo);

        var valid = true;
        let errorMessage = "";

        var ErrorPayload = {
            ErrorCode: "",
            ErrorSource: "RegisterPageValidateCommonData_promise",
            ErrorMessage: "",
        };

        const {
            CommunityId,
            AppointmentType,
            Notes,
            GaClientID,
            PagePath,
            Origin,
            ContactType,
            LeadSource,
            SubSource,
            SmsOptIn,
            EmailOptIn,
        } = CommonInfo;

        if (CommunityId == null || CommunityId == "") {
            valid = false;
            errorMessage = errorMessage.concat("Error validating CommunityId.\n");
        }
        if (AppointmentType == null || AppointmentType == "") {
            //console.log("AppointmentType");
            valid = false;
            errorMessage = errorMessage.concat("Error validating AppointmentType.\n");
        }
        //if (GaClientID == null || GaClientID == "") {
        //    valid = false;
        //    errorMessage = errorMessage.concat("Error validating GaClientID.\n");
        //}
        if (PagePath == null || PagePath == "") {
            //console.log("PagePath");
            valid = false;
            errorMessage = errorMessage.concat(
                "Error validating PagePathPagePath.\n"
            );
        }
        if (Origin == null || Origin == "") {
            //console.log("Origin");
            valid = false;
            errorMessage = errorMessage.concat("Error validating Origin.\n");
        }
        if (ContactType == null || ContactType == "") {
            //console.log("ContactType");
            valid = false;
            errorMessage = errorMessage.concat("Error validating ContactType.\n");
        }
        if (LeadSource == null || LeadSource == "") {
            //console.log("LeadSource");
            valid = false;
            errorMessage = errorMessage.concat("Error validating AppointmentType.\n");
        }
        if (SubSource == null || SubSource == "") {
            //console.log("SubSource");
            valid = false;
            errorMessage = errorMessage.concat("Error validating SubSource.\n");
        }

        //console.log("errorMessage " + errorMessage);
        //console.log(errorMessage.length);
        //console.log(valid);
        if (errorMessage.length > 0 || !valid) {
            //console.log(valid);
            //console.log("RegisterPageValidateCommonData_promise");
            //console.log(payload);
            reject(ErrorPayload);
        } else {
            //console.log(valid);
            resolve(payload);
        }
    });
};

const RegisterPageHomebuyerGeneratePayload_promise = (payload = {}) => {
    return new Promise((resolve, reject) => {
        console.log("RegisterPageHomebuyerGeneratePayload_promise");
        var homeBuyerCheckBox = $("#SFC_HomebuyerCheckbox").is(":checked");

        var homeBuyerFirstName = $("#HomebuyerFirstName").val();
        var homeBuyerLastName = $("#HomebuyerLastName").val();
        var homeBuyerEmail = $("#HomebuyerEmailAddress").val();
        var homeBuyerPhone = $("#HomebuyerMobilePhoneNumber").val();
        var homeBuyerSMS = $("#HomeBuyerSMSOptIn").is(":checked");

        payload["HomeBuyerCheckbox"] = homeBuyerCheckBox;
        payload["HomebuyerInfo"] = {
            FirstName: homeBuyerFirstName,
            LastName: homeBuyerLastName,
            Email: homeBuyerEmail,
            Phone: homeBuyerPhone,
            SMSOptIn: homeBuyerSMS,
        };

        //console.log(payload);
        var ErrorPayload = {
            ErrorCode: "",
            ErrorSource: "RegisterPageHomebuyerGeneratePayload_promise",
            ErrorMessage: "",
        };

        if (!payload.HomeBuyerCheckbox) {
            ErrorPayload.ErrorMessage =
                "Homebuyer value was changed before submitting form";
            reject(ErrorPayload);
        }

        resolve(payload);

        //console.log("homeBuyerSMS: " + homeBuyerSMS);
        //console.log("RegisterPageHomebuyerGeneratePayload_promise payload: " + JSON.stringify(payload));
    });
};

const RegisterPageHomebuyerValidate_promise = (payload) => {
    return new Promise((resolve, reject) => {
        console.log("RegisterPageHomebuyerValidate_promise");
        const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        const emailRegex =
            /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.+[a-zA-Z0-9.]/;
        const firstNameRegex = /^[A-z\s]{1,100}/;
        const lastNameRegex = /^[A-z\s]{1,100}/;
        //console.log("RegisterPageHomebuyerValidate_promise");
        const { HomeBuyerCheckbox, HomebuyerInfo } = payload;

        var valid = true;
        var errorMessage = "";

        var ErrorPayload = {
            ErrorCode: "",
            ErrorSource: "RegisterPageHomebuyerValidate_promise",
            ErrorMessage: "",
        };

        if (HomeBuyerCheckbox) {
            const { FirstName, LastName, Phone, Email } = HomebuyerInfo;

            //console.log("HomebuyerInfo");
            //console.log(HomebuyerInfo);

            if (
                FirstName == null ||
                FirstName == "" ||
                !firstNameRegex.test(FirstName)
            ) {
                valid = false;
                errorMessage = errorMessage.concat(
                    "Error validating Homebuyer First Name.\n"
                );
                $("#HomebuyerFirstNameError").show("slow");
            } else $("#HomebuyerFirstNameError").hide("fast");

            if (LastName == null || LastName == "" || !lastNameRegex.test(LastName)) {
                valid = false;
                errorMessage = errorMessage.concat(
                    "Error validating Homebuyer Last Name.\n"
                );
                $("#HomebuyerLastNameError").show("slow");
            } else $("#HomebuyerLastNameError").hide("fast");

            if (Phone == null || Phone == "" || !phoneRegex.test(Phone)) {
                valid = false;
                errorMessage = errorMessage.concat(
                    "Error validating Homebuyer Phone.\n"
                );
                $("#HomebuyerMobilePhoneNumberError").show("slow");
            } else $("#HomebuyerMobilePhoneNumberError").hide("fast");

            if (Email == null || Email == "" || !emailRegex.test(Email)) {
                valid = false;
                errorMessage = errorMessage.concat(
                    "Error validating Homebuyer Email.\n"
                );
                $("#HomebuyerEmailAddressError").show("slow");
            } else $("#HomebuyerEmailAddressError").hide("fast");
        }

        if (errorMessage.length > 0 || !valid) {
            ErrorPayload.ErrorMessage = errorMessage;
            //console.log("RegisterPageHomebuyerValidate_promise Error Message: " + errorMessage);
            reject(ErrorPayload);
        } else {
            //console.log("RegisterPageHomebuyerValidate_promise payload: " + JSON.stringify(payload));
            resolve(payload);
        }
    });
};

const RegisterPageHomebuyerSubmitRequest_promise = (payload) => {
    return new Promise((resolve, reject) => {
        //console.log("RegisterPageHomebuyerSubmitRequest_promise:");
        //console.log("payload:");
        //console.log(payload);
        const salesforceServiceUrl = $("#salesforce-tour-schedule-form-modal").data(
            "salesforce-service-url"
        );
        if (payload == null) {
            //console.log("payload was null");
            reject({
                Message:
                    "RegisterPageHomebuyerSubmitRequest_promise: There was a problem generating the data payload",
            });
        } else {
            var submitPayload = {
                appointmentBookingRequest: {
                    communityNumber: payload.CommonInfo.CommunityId.toString(),
                    bookingDate: payload.CommonInfo.BookingDate,
                    bookingHour: payload.CommonInfo.BookingHour,
                    firstName: payload.HomebuyerInfo.FirstName,
                    lastName: payload.HomebuyerInfo.LastName,
                    phone: payload.HomebuyerInfo.Phone,
                    email: payload.HomebuyerInfo.Email,
                    smsOptIn: payload.HomeBuyerInfo.SMSOptIn,
                    appointmentType: payload.CommonInfo.AppointmentType,
                    notes: payload.CommonInfo.Notes,
                    gaClientId: payload.CommonInfo.GaClientID,
                    pagePath: payload.CommonInfo.PagePath,
                    origin: payload.CommonInfo.Origin,
                    contactType: payload.CommonInfo.ContactType,
                    leadSource: payload.CommonInfo.LeadSource,
                    subSource: payload.CommonInfo.SubSource,
                    realtorID: "",
                    //"smsOptIn": payload.CommonInfo.SmsOptIn,
                    emailOptIn: payload.CommonInfo.EmailOptIn,
                },
            };
            //console.log("submitPayload:");
            //console.log(submitPayload);
            //console.log("RegisterPageHomebuyerSubmitRequest_promise var submitPayload: " + submitPayload);

            $.ajax({
                method: "POST",
                url:
                    salesforceServiceUrl +
                    "/api/Salesforce/PostBookAppointment/SubmitAppointment",
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify(submitPayload),
                success: function (data) {
                    //console.log(data);
                    var responseJson = data;
                    var ErrorPayload = null;
                    payload["Data"] = data;
                    //console.log(responseJson);
                    if (
                        Array.isArray(responseJson.appointmentBookingResult) &&
                        responseJson.appointmentBookingResult.length > 0
                    ) {
                        if (
                            responseJson.appointmentBookingResult[0].errorCode != null &&
                            responseJson.appointmentBookingResult[0].errorCode != 0
                        ) {
                            ErrorPayload = SalesforceschedulerSubmitAppointmentProcessErrors({
                                ErrorCode: responseJson.appointmentBookingResult[0].errorCode,
                                ErrorSource: "RegisterPageSubmitHomebuyerRequest_promise",
                            });
                            workflow.onErr = true;
                            workflow.renderStep();
                            reject(ErrorPayload);
                        } else {
                            if (
                                payload.Data != null &&
                                payload.Data.appointmentBookingResult != null &&
                                Array.isArray(payload.Data.appointmentBookingResult) &&
                                payload.Data.appointmentBookingResult.length > 0
                            ) {
                                const { salesCounselorFirstName, salesCounselorLastName } =
                                    payload.Data.appointmentBookingResult[0];

                                if (
                                    salesCounselorFirstName != null &&
                                    salesCounselorLastName != null
                                )
                                    RegisterPageAttachCounselor(
                                        salesCounselorFirstName,
                                        salesCounselorLastName
                                    );

                                workflow.renderStep();
                                resolve(payload);
                            } else {
                                ErrorPayload =
                                    SalesforceschedulerSubmitAppointmentProcessErrors({
                                        ErrorCode: 333,
                                        ErrorSource: "RegisterPageHomebuyerSubmitRequest_promise",
                                    });
                                workflow.onErr = true;
                                workflow.renderStep();
                                reject(ErrorPayload);
                            }
                        }
                    } else if (
                        data != null &&
                        data.responseJson != null &&
                        data.responseJson.status != null
                    ) {
                        const { ErrorCode, ErrorMessage, ErrorSource } = data.responseJson;

                        var ErrorPayload = null;
                        if (ErrorCode != null)
                            SalesforceschedulerSubmitAppointmentProcessErrors({
                                ErrorCode: ErrorCode,
                                ErrorSource: ErrorSource,
                            });
                    } else {
                        const ErrorPayload =
                            SalesforceschedulerSubmitAppointmentProcessErrors({
                                ErrorCode: 999,
                            });
                        workflow.onErr = true;
                        workflow.renderStep();
                        reject(ErrorPayload);
                    }
                },
                error: function (error) {
                    //console.log(error);
                    var ErrorPayload = null;

                    if (error != null) {
                        const { ErrorCode, ErrorMessage, ErrorSource } = error;
                        if (
                            ErrorCode != null &&
                            ErrorMessage != null &&
                            ErrorSource != null
                        ) {
                            ErrorPayload = SalesforceschedulerSubmitAppointmentProcessErrors({
                                ErrorCode: ErrorCode,
                                ErrorSource: ErrorSource,
                            });
                        } else {
                            ErrorPayload = SalesforceschedulerSubmitAppointmentProcessErrors({
                                ErrorCode: 999,
                            });
                        }
                    } else {
                        ErrorPayload = SalesforceschedulerSubmitAppointmentProcessErrors({
                            ErrorCode: 999,
                        });
                    }
                    workflow.onErr = true;
                    workflow.renderStep();
                    reject(ErrorPayload);
                },
            });
        }
    });
};

const RegisterPageAttachCounselor = (firstname, lastname) => {
    if (
        firstname == null ||
        firstname == "" ||
        lastname == null ||
        lastname == ""
    ) {
        $("#SFC_TourThankYouPage_WSVT_Counselor").text(null);
        $("#SFC_TourThankYouPage_WSIP_Counselor").text(null);
    } else {
        var counselor = `${firstname} ${lastname}`;
        $("#SFC_TourThankYouPage_WSVT_Counselor").text(counselor);
        $("#SFC_TourThankYouPage_WSIP_Counselor").text(counselor);
    }
};

const RegisterPageGenerateAgentPayload_promise = (payload = {}) => {
    return new Promise((resolve, reject) => {
        console.log("RegisterPageGenerateAgentPayload_promise");
        var agentCheckBox = $("#SFC_AgentCheckbox").is(":checked");

        var agentFirstName = $("#AgentFirstName").val();
        var agentLastName = $("#AgentLastName").val();
        var agentEmail = $("#AgentEmailAddress").val();
        var agentPhone = $("#AgentMobilePhoneNumber").val();
        var agentAgencyName = $("#AgentAgency").val();
        var agentZipcode = $("#AgentZipcode").val();
        var agentSMS = $("#AgentSMSOptIn").is(":checked");

        payload["AgentCheckbox"] = agentCheckBox;
        payload["AgentInfo"] = {
            FirstName: agentFirstName,
            LastName: agentLastName,
            Email: agentEmail,
            Phone: agentPhone,
            Agency: agentAgencyName,
            Zipcode: agentZipcode,
            SMSOptIn: agentSMS,
        };

        //console.log(payload);
        var ErrorPayload = {
            ErrorCode: "",
            ErrorSource: "RegisterPageGenerateAgentPayload_promise",
            ErrorMessage: "",
        };

        if (!payload.AgentCheckbox) {
            ErrorPayload.ErrorMessage =
                "Agent value was changed before submitting form";
            reject(ErrorPayload);
        }

        resolve(payload);

        console.log("var agentSMS: " + agentSMS);
        console.log(
            "RegisterPageGenerateAgentPayload_promise payload: " +
            JSON.stringify(payload)
        );
    });
};

const RegisterPageGenerateAgentRegistrationPayload_promise = (payload = {}) => {
    return new Promise((resolve, reject) => {
        console.log("RegisterPageGenerateAgentRegistrationPayload_promise");
        var agentFormRegistrationPayload = {
            Agents: [],
        };
        const { CommonInfo, AgentInfo, HomebuyerInfo } = payload;

        var CommunityID = $("#salesforce-tour-schedule-form-modal").data(
            "external-id"
        );
        var MetroAreaExternalID = $("#salesforce-tour-schedule-form-modal").data(
            "metro-external-id"
        );
        //var MetroAreaExternalID = "4";
        var GaClientID = $("#salesforceTourSchedulerGAClientId").val();
        var PagePath = $("#salesforceTourSchedulerPagePath").val();
        var Origin = __origin;
        var ContactType = __contactType;
        var PrimaryLeadSource = CommonInfo.PrimiaryLeadSource;
        var LeadSource = CommonInfo.LeadSource;
        var SubSource = CommonInfo.SubSource;
        var LeadSubSource = "Request a Tour - " + CommonInfo.LeadSubSource;

        var clientPayload = [];
        if (HomebuyerInfo != null) {
            const { FirstName, LastName, Email, Phone } = HomebuyerInfo;

            clientPayload.push({
                FirstName: FirstName,
                LastName: LastName,
                Phone: Phone,
                Email: Email,
            });
        }

        var agentLeadPayload = {
            FirstName: AgentInfo.FirstName,
            LastName: AgentInfo.LastName,
            Phone: AgentInfo.Phone,
            Email: AgentInfo.Email,
            FormName: "Salesforce Scheduler",
            GA_ClientId: GaClientID,
            PagePath: PagePath,
            Origin: Origin,
            ContactType: ContactType,
            PrimiaryLeadSource: PrimaryLeadSource,
            LeadSource: LeadSource,
            SubSource: SubSource,
            LeadSubSource: LeadSubSource,
            Clients: clientPayload,
            CommunityNumber: CommunityID,
            MetroArea: MetroAreaExternalID,
            Comments: CommonInfo.Notes,
            Broker: {
                CompanyName: AgentInfo.Agency,
                ZipCode: AgentInfo.Zipcode,
            },
        };
        agentFormRegistrationPayload.Agents.push(agentLeadPayload);
        payload["AgentRegistrationPayload"] = agentFormRegistrationPayload;

        console.log(
            "RegisterPageGenerateAgentRegistrationPayload_promise: " +
            JSON.stringify(payload)
        );
        //console.log(payload);
        resolve(payload);
    });
};

const RegisterPageSubmitAgentRegistrationForm_promise = (payload = {}) => {
    return new Promise((resolve, reject) => {
        const { AgentRegistrationPayload } = payload;

        const salesforceServiceUrl = $("#salesforce-tour-schedule-form-modal").data(
            "salesforce-service-url"
        );

        var ErrorPayload = {
            ErrorCode: "",
            ErrorSource: "RegisterPageSubmitAgentRegistrationForm_promise",
            ErrorMessage: "",
        };
        console.log("RegisterPageSubmitAgentRegistrationForm_promise");
        console.log(payload);
        //console.log(AgentRegistrationPayload);
        //console.log(AgentRegistrationPayload.Agents.length);
        if (
            AgentRegistrationPayload == null ||
            AgentRegistrationPayload.Agents.length == 0
        ) {
            ErrorPayload.ErrorMessage = "AgentRegistrationPayload was null";
            //console.log(ErrorPayload);
            reject(ErrorPayload);
        } else {
            $.ajax({
                method: "POST",
                url: salesforceServiceUrl + "/api/Webformleads/scheduler/agentbooking",
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify(AgentRegistrationPayload),
                success: function (data) {
                    //console.log("success");
                    var responseJson = data;
                    const { type, sfdC_RealtorId, success, errorMessage, errorCode } =
                        responseJson;
                    //console.log(responseJson);
                    if (success) {
                        //console.log("success");
                        payload.AgentInfo["RealtorID"] = sfdC_RealtorId;
                        resolve(payload);
                    } else {
                        //console.log("was not a success");
                        ErrorPayload.ErrorMessage = errorMessage;
                        ErrorPayload.ErrorCode = errorCode;
                        workflow.onErr = true;
                        workflow.renderStep();
                        reject(ErrorPayload);
                    }
                },
                error: function (error) {
                    ErrorPayload = {
                        ErrorCode: "",
                        ErrorSource: "RegisterPageSubmitAgentRegistrationForm_promise",
                        ErrorMessage: error,
                    };
                    console.log("Error after the api call");
                    console.log(ErrorPayload);
                    workflow.onErr = true;
                    workflow.renderStep();
                    reject(ErrorPayload);
                },
            });
        }
    });
};

const RegisterPageAgentValidate_promise = (payload) => {
    return new Promise((resolve, reject) => {
        console.log("RegisterPageAgentValidate_promise");
        const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        const emailRegex =
            /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.+[a-zA-Z0-9.]/;
        const zipcodeRegex = /^[0-9]{5}(?:-[0-9]{4})?$/;
        const firstNameRegex = /^[A-z\s]{1,100}/;
        const lastNameRegex = /^[A-z\s]{1,100}/;
        const agencyRegex = /^[A-z\s]{1,100}/;

        const { AgentCheckbox, AgentInfo } = payload;

        var valid = true;
        let errorMessage = "";

        var ErrorPayload = {
            ErrorCode: "",
            ErrorSource: "RegisterPageAgentValidate_promise",
            ErrorMessage: "",
        };

        if (AgentCheckbox) {
            const { FirstName, LastName, Phone, Email, Agency, Zipcode } = AgentInfo;
            //console.log(AgentInfo);

            if (
                FirstName == null ||
                FirstName == "" ||
                !firstNameRegex.test(FirstName)
            ) {
                valid = false;
                errorMessage = errorMessage.concat(
                    "Error validating Agent First Name.\n"
                );
                $("#AgentFirstNameError").show("slow");
            } else $("#AgentFirstNameError").hide("fast");

            if (LastName == null || LastName == "" || !lastNameRegex.test(LastName)) {
                valid = false;
                errorMessage = errorMessage.concat(
                    "Error validating Agent Last Name.\n"
                );
                $("#AgentLastNameError").show("slow");
            } else $("#AgentLastNameError").hide("fast");

            if (Phone == null || Phone == "" || !phoneRegex.test(Phone)) {
                valid = false;
                errorMessage = errorMessage.concat("Error validating Agent Phone.\n");
                $("#AgentMobilePhoneNumberError").show("slow");
            } else $("#AgentMobilePhoneNumberError").hide("fast");

            if (Email == null || Email == "" || !emailRegex.test(Email)) {
                valid = false;
                errorMessage = errorMessage.concat("Error validating Agent Email.\n");
                $("#AgentEmailAddressError").show("slow");
            } else $("#AgentEmailAddressError").hide("fast");

            if (Agency == null || Agency == "" || !agencyRegex.test(Agency)) {
                valid = false;
                errorMessage = errorMessage.concat("Error validating Agent Agency.\n");
                $("#AgentAgencyError").show("slow");
            } else $("#AgentAgencyError").hide("fast");

            if (Zipcode == null || Zipcode == "" || !zipcodeRegex.test(Zipcode)) {
                valid = false;
                errorMessage = errorMessage.concat("Error validating Agent Zipcode.\n");
                $("#AgentZipcodeError").show("slow");
            } else $("#AgentZipcodeError").hide("fast");
        } else {
            errorMessage = errorMessage.concat(
                "Checkbox value was changed while submitting.\n"
            );
            ErrorPayload.ErrorMessage = errorMessage;
            reject(ErrorPayload);
        }

        if (errorMessage.length > 0 || !valid) {
            ErrorPayload.ErrorMessage = errorMessage;
            reject(ErrorPayload);
        } else {
            resolve(payload);
        }
        //conosle.log("RegisterPageAgentValidate_promise: " + JSON.stringify(payload));
    });
};

const RegisterPageSubmitAgentRequest_promise = (payload) => {
    return new Promise((resolve, reject) => {
        const salesforceServiceUrl = $("#salesforce-tour-schedule-form-modal").data(
            "salesforce-service-url"
        );
        //console.log("RegisterPageSubmitAgentRequest_promise");
        if (payload == null) {
            //console.log("RegisterPageSubmitAgentRequest_promise");
            reject({
                Message:
                    "GuidedTourSubmitAppointment_promise: There was a problem generaqting the data payload",
            });
        } else {
            var PrimaryContact = {
                FirstName:
                    payload.HomebuyerInfo == null
                        ? payload.AgentInfo.FirstName
                        : payload.HomebuyerInfo.FirstName,
                LastName:
                    payload.HomebuyerInfo == null
                        ? payload.AgentInfo.LastName
                        : payload.HomebuyerInfo.LastName,
                Phone:
                    payload.HomebuyerInfo == null
                        ? payload.AgentInfo.Phone
                        : payload.HomebuyerInfo.Phone,
                Email:
                    payload.HomebuyerInfo == null
                        ? payload.AgentInfo.Email
                        : payload.HomebuyerInfo.Email,
            };

            //console.log(PrimaryContact);
            var submitPayload = {
                appointmentBookingRequest: {
                    communityNumber: payload.CommonInfo.CommunityId.toString(),
                    bookingDate: payload.CommonInfo.BookingDate,
                    bookingHour: payload.CommonInfo.BookingHour,
                    firstName: PrimaryContact.FirstName,
                    lastName: PrimaryContact.LastName,
                    phone: PrimaryContact.Phone,
                    email: PrimaryContact.Email,
                    appointmentType: payload.CommonInfo.AppointmentType,
                    notes: payload.CommonInfo.Notes,
                    gaClientId: payload.CommonInfo.GaClientID,
                    pagePath: payload.CommonInfo.PagePath,
                    origin: payload.CommonInfo.Origin,
                    contactType: payload.CommonInfo.ContactType,
                    primaryLeadSource: payload.CommonInfo.PrimaryLeadSource,
                    leadSource: payload.CommonInfo.LeadSource,
                    subSource: payload.CommonInfo.SubSource,
                    leadSubSource: payload.CommonInfo.LeadSubSource,
                    smsOptIn: payload.CommonInfo.SmsOptIn,
                    emailOptIn: payload.CommonInfo.EmailOptIn,
                    RealtorID: payload.AgentInfo.RealtorID,
                },
            };
            console.log(
                "RegisterPageSubmitAgentRequest_promise submitpayload: " +
                JSON.stringify(payload)
            );

            //console.log(submitPayload);
            $.ajax({
                method: "POST",
                url:
                    salesforceServiceUrl +
                    "/api/Salesforce/PostBookAppointment/SubmitAppointment",
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify(submitPayload),
                success: function (data) {
                    //console.log(data);
                    var responseJson = data;
                    var ErrorPayload = null;
                    payload["Data"] = data;
                    //console.log(responseJson);
                    if (
                        Array.isArray(responseJson.appointmentBookingResult) &&
                        responseJson.appointmentBookingResult.length > 0
                    ) {
                        if (
                            responseJson.appointmentBookingResult[0].errorCode != null &&
                            responseJson.appointmentBookingResult[0].errorCode != 0
                        ) {
                            ErrorPayload = SalesforceschedulerSubmitAppointmentProcessErrors({
                                ErrorCode: responseJson.appointmentBookingResult[0].errorCode,
                                ErrorSource: "RegisterPageSubmitAgentRequest_promise",
                            });
                            workflow.onErr = true;
                            workflow.renderStep();
                            reject(ErrorPayload);
                        } else {
                            if (
                                payload.Data != null &&
                                payload.Data.appointmentBookingResult != null &&
                                Array.isArray(payload.Data.appointmentBookingResult) &&
                                payload.Data.appointmentBookingResult.length > 0
                            ) {
                                const { salesCounselorFirstName, salesCounselorLastName } =
                                    payload.Data.appointmentBookingResult[0];

                                if (
                                    salesCounselorFirstName != null &&
                                    salesCounselorLastName != null
                                )
                                    RegisterPageAttachCounselor(
                                        salesCounselorFirstName,
                                        salesCounselorLastName
                                    );

                                workflow.renderStep();
                                resolve(payload);
                            } else {
                                ErrorPayload =
                                    SalesforceschedulerSubmitAppointmentProcessErrors({
                                        ErrorCode: 333,
                                        ErrorSource: "RegisterPageSubmitAgentRequest_promise",
                                    });
                                workflow.onErr = true;
                                workflow.renderStep();
                                reject(ErrorPayload);
                            }
                        }
                    } else if (
                        data != null &&
                        data.responseJson != null &&
                        data.responseJson.status != null
                    ) {
                        const { ErrorCode, ErrorMessage, ErrorSource } = data.responseJson;

                        var ErrorPayload = null;
                        if (ErrorCode != null)
                            SalesforceschedulerSubmitAppointmentProcessErrors({
                                ErrorCode: ErrorCode,
                                ErrorSource: ErrorSource,
                            });
                    } else {
                        const ErrorPayload =
                            SalesforceschedulerSubmitAppointmentProcessErrors({
                                ErrorCode: 999,
                            });
                        workflow.onErr = true;
                        workflow.renderStep();
                        reject(ErrorPayload);
                    }
                },
                error: function (error) {
                    console.log(error);
                    var ErrorPayload = null;

                    if (error != null) {
                        const { ErrorCode, ErrorMessage, ErrorSource } = error;
                        if (
                            ErrorCode != null &&
                            ErrorMessage != null &&
                            ErrorSource != null
                        ) {
                            ErrorPayload = SalesforceschedulerSubmitAppointmentProcessErrors({
                                ErrorCode: ErrorCode,
                                ErrorSource: ErrorSource,
                            });
                        } else {
                            ErrorPayload = SalesforceschedulerSubmitAppointmentProcessErrors({
                                ErrorCode: 999,
                            });
                        }
                    } else {
                        ErrorPayload = SalesforceschedulerSubmitAppointmentProcessErrors({
                            ErrorCode: 999,
                        });
                    }
                    workflow.onErr = true;
                    workflow.renderStep();
                    reject(ErrorPayload);
                },
            });
        }
    });
};

const SalesforceschedulerSubmitAppointmentProcessErrors = (ErrorPayload) => {
    //console.log(ErrorPayload);

    const DefaultError = {
        ErrorMessage:
            "We encountered an unsuspected error, please refresh your page and try again.",
        ErrorSource: "SalesforceschedulerSubmitAppointmentProcessErrors",
        ErrorCode: 999,
    };

    if (ErrorPayload == null || ErrorPayload.ErrorCode == 999)
        return DefaultError;
    else {
        const { ErrorCode, ErrorSource, ErrorMessage } = ErrorPayload;

        if (ErrorCode == null) return DefaultError;
        else {
            switch (ErrorCode) {
                case 101:
                    $("#SFC_ErrorPage_Message").text(__Error101);
                    return {
                        ErrorCode: 101,
                        ErrorMessage: __Error101,
                        ErroSource: ErrorSource,
                    };
                case 303:
                    $("#SFC_ErrorPage_Message").text(__Error303);
                    return {
                        ErrorCode: 303,
                        ErrorMessage: __Error303,
                        ErroSource: ErrorSource,
                    };
                case 333:
                    $("#SFC_ErrorPage_Message").text(__Error333);
                    return {
                        ErrorCode: 333,
                        ErrorMessage: __Error333,
                        ErroSource: ErrorSource,
                        ErrorMessage: ErrorMessage,
                    };
                case 403:
                    $("#SFC_ErrorPage_Message").text(__Error403);
                    return {
                        ErrorCode: 403,
                        ErrorMessage: __Error403,
                        ErroSource: ErrorSource,
                    };
                case 409:
                    $("#SFC_ErrorPage_Message").text(__Error409);
                    return {
                        ErrorCode: 409,
                        ErrorMessage: __Error409,
                        ErroSource: ErrorSource,
                    };
                case 999:
                    $("#SFC_ErrorPage_Message").text(DefaultError.ErrorMessage);
                    return DefaultError;
                default:
                    $("#SFC_ErrorPage_Message").text(DefaultError.ErrorMessage);
                    return DefaultError;
            }
        }
    }
};

const RegisterPageSetLoading_promise = () => {
    return new Promise((resolve, reject) => {
        console.log("RegisterPageSetLoading_promise");
        $("#SFC_TourRegistrationPage_spinner").show(200);
        $("#SFC_TourRegistrationPage_formselect").hide(200);
        $("#SFC_TourRegistrationPage_forms").hide(200);
        $("#SFC_AgentIndependentSection").hide(200);
        resolve();
    });
};

const RegisterPageClearLoading_promise = (payload) => {
    return new Promise((resolve, reject) => {
        $("#SFC_TourRegistrationPage_spinner").hide(100);
        $("#SFC_TourRegistrationPage_formselect").show(800);
        $("#SFC_TourRegistrationPage_forms").show(800);
        $("#SFC_AgentIndependentSection").show(800);
        resolve();
    });
};

const RegisterPageClearLoadingError_promise = (payload) => {
    return new Promise((resolve, reject) => {
        $("#SFC_TourRegistrationPage_spinner").hide(100);
        $("#SFC_TourRegistrationPage_formselect").show(800);
        $("#SFC_TourRegistrationPage_forms").show(800);
        $("#SFC_AgentIndependentSection").show(800);
        resolve();
    });
};

const RegisterPageBookATourHomebuyerOnly = () => {
    return RegisterPageSetLoading_promise()
        .catch((Error) => {
            const { ErrorCode, ErrorSource, ErrorMessage } = Error;

            console.log(
                `${ErrorSource} Generated the following error: ${ErrorMessage}`
            );
        })
        .finally(() => RegisterPageClearLoading_promise());
};

const RegisterPageBookATourHomebuyerGeneratePayload = () => {
    return new Promise((resolve, reject) => {
        var communityExternalID = null;
        var bookingDate = null;
        var bookingHour = null;
        var firstName = null;
        var lastName = null;
        var phoneNumber = null;
        var email = null;
        var appointmentType = null;
        var notes = null;
        var gaClientId = $("#salesforceTourSchedulerGAClientId").val();

        var payload = {
            appointmentBookingRequest: {
                communityNumber: communityExternalID,
                bookingDate: bookingDate,
                bookingHour: bookingHour,
                firstName: firstName,
                lastName: lastName,
                phone: phoneNumber,
                email: email,
                appointmentType: tourType,
                notes: notes,
                gaClientId: gaClientId,
            },
        };

        resolve(payload);
    });
};

function RegisterPageLeadCreationHomebuyerOnlyGeneratePayload_promise() {
    return new Promise((resolve, reject) => {
        var homeBuyerFirstName = $("#HomebuyerFirstName").val();
        var homeBuyerLastName = $("#HomebuyerLastName").val();
        var homeBuyerEmail = $("#HomebuyerEmailAddress").val();
        var homeBuyerPhone = $("#HomebuyerMobilePhoneNumber").val();
        var homeBuyerSMS = $("#HomeBuyerSMSOptIn").is(":checked");
        var communitySitecoreID = $("#salesforce-tour-schedule-form-modal").data(
            "community-sitecore-id"
        );
        var metroSitecoreID = $("#salesforce-tour-schedule-form-modal").data(
            "metro-sitecore-id"
        );

        var payload = {
            FirstName: homeBuyerFirstName,
            LastName: homeBuyerLastName,
            EmailAddress: homeBuyerEmail,
            PhoneNumber: homeBuyerPhone,
            SMSOptIn: homeBuyerSMS,
            UnderstandTermsPrivacyPolicy: true,
            MetroArea: metroSitecoreID,
            Community: communitySitecoreID,
            SitecoreItemId: "{4F6F91AB-ABCA-4174-8C8D-2E9C02D5ADF7}",
            ContactListId: $("#salesforce-tour-schedule-form-modal").data(
                "contact-list"
            ),
            TourType: $("#virtually").prop("checked")
                ? __virtualTour
                : __inPersonTour,
            ContactUserType: "Homebuyer",
            GaClientId: $("#salesforceTourSchedulerGAClientId").val(),
            Origin: "Web",
            ContactType: "Meritagehomes.com Forms",
            LeadSource: "SalesforceScheduler",
        };

        console.log(
            "RegisterPageLeadCreationHomebuyerOnlyGeneratePayload_promise:" +
            JSON.stringify(payload)
        );
        console.log(payload);

        resolve(payload);
    });
}

function RegisterPageLeadCreationHomebuyerOnlyValidatePayload_promise(payload) {
    return new Promise((resolve, reject) => {
        const { FirstName, LastName, EmailAddress, PhoneNumber } = payload;

        console.log("RegisterPageLeadCreationHomebuyerOnlyValidatePayload_promise");
        console.log(payload);
        const firstNameRegex = /^[A-z\s]{1,100}/;
        const lastNameRegex = /^[A-z\s]{1,100}/;
        const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        const emailRegex =
            /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.+[a-zA-Z0-9.]/;
        var valid = true;
        var errorMessage = "";

        if (
            FirstName == null ||
            FirstName == "" ||
            !firstNameRegex.test(FirstName)
        ) {
            valid = false;
            errorMessage = errorMessage.concat(
                "Error validating Homebuyer First Name.\n"
            );
            $("#HomebuyerFirstNameError").show("slow");
        } else $("#HomebuyerFirstNameError").hide("fast");

        if (LastName == null || LastName == "" || !lastNameRegex.test(LastName)) {
            valid = false;
            errorMessage = errorMessage.concat(
                "Error validating Homebuyer Last Name.\n"
            );
            $("#HomebuyerLastNameError").show("slow");
        } else $("#HomebuyerLastNameError").hide("fast");

        if (
            PhoneNumber == null ||
            PhoneNumber == "" ||
            !phoneRegex.test(PhoneNumber)
        ) {
            valid = false;
            errorMessage = errorMessage.concat("Error validating Homebuyer Phone.\n");
            $("#HomebuyerMobilePhoneNumberError").show("slow");
        } else $("#HomebuyerMobilePhoneNumberError").hide("fast");

        if (
            EmailAddress == null ||
            EmailAddress == "" ||
            !emailRegex.test(EmailAddress)
        ) {
            valid = false;
            errorMessage = errorMessage.concat("Error validating Homebuyer Email.\n");
            $("#HomebuyerEmailAddressError").show("slow");
        } else $("#HomebuyerEmailAddressError").hide("fast");

        if (!valid) {
            var ErrorPayload = {
                ErrorCode: "",
                ErrorSource:
                    "RegisterPageLeadCreationHomebuyerOnlyValidatePayload_promise",
                ErrorMessage: errorMessage,
            };
            //console.log(ErrorPayload);
            reject(ErrorPayload);
        } else {
            conosle.log(
                "RegisterPageLeadCreationHomebuyerOnlyValidatePayload_promise(payload): " +
                JSON.stringify(payload)
            );
            resolve(payload);
        }
    });
}

const RegisterPageLeadCreationHomebuyerOnlySubmit_promise = (payload) => {
    return new Promise((resolve, reject) => {
        console.log(
            "RegisterPageLeadCreationHomebuyerOnlySubmit_promise: " +
            JSON.stringify(payload)
        );
        $.ajax({
            url: "/api/sitecore/ContactUsForm",
            contentType: "application/json;charset=utf-8",
            method: "POST",
            data: JSON.stringify(payload),
            complete: function (data) {
                //console.log(data);
                var responseJson = data.responseJSON;
                payload.Data = responseJson;
                workflow.renderStep();
                resolve(payload);
            },
            error: function (error) {
                console.log(error);
                var ErrorPayload = {
                    ErrorCode: "",
                    ErrorSource: "RegisterPageLeadCreationHomebuyerOnlySubmit_promise",
                    ErrorMessage: error,
                };
                workflow.onErr = true;
                workflow.renderStep();
                reject(ErrorPayload);
            },
        });
    });
};

const SelfGuidedDuringBusinessTourAction = () => {
    var agentCheckBox = $("#SFC_AgentCheckbox").is(":checked");
    var homeBuyerCheckBox = $("#SFC_HomebuyerCheckbox").is(":checked");

    console.log("RegisterPageSubmit_action:");
    console.log("agentCheckBox:" + agentCheckBox);
    console.log("homeBuyerCheckBox:" + homeBuyerCheckBox);

    if (agentCheckBox && homeBuyerCheckBox) {
        //console.log("RegisterPageAgentAndHomebuyerDuringBusinessSubmit_action");
        return RegisterPageAgentAndHomebuyerDuringBusinessSubmit_action();
    } else if (agentCheckBox) {
        //console.log("RegisterPageAgentDuringBusinessSubmit_action");
        return RegisterPageAgentDuringBusinessSubmit_action();
    } else if (homeBuyerCheckBox) {
        //console.log("RegisterPageHomebuyerDuringBusinessSubmit_action");
        return RegisterPageHomebuyerDuringBusinessSubmit_action();
    }
};

const RegisterPageAgentAndHomebuyerDuringBusinessSubmit_action = () => {
    return RegisterPageSetLoading_promise()
        .then(RegisterPageGenerateCommonPayload_promise)
        .then(RegisterPageValidateDuringBusinessHoursCommonData_promise)
        .then(RegisterPageHomebuyerGeneratePayload_promise)
        .then(RegisterPageHomebuyerValidate_promise)
        .then(RegisterPageGenerateAgentPayload_promise)
        .then(RegisterPageAgentValidate_promise)
        .then(RegisterPageGenerateAgentRegistrationPayload_promise)
        .then(RegisterPageSubmitAgentRegistrationForm_promise)
        .catch((Error) => {
            const { ErrorCode, ErrorSource, ErrorMessage } = Error;

            console.log(
                `${ErrorSource} Generated the following error: ${ErrorMessage}`
            );
        })
        .finally(() => RegisterPageClearLoading_promise());
};

const RegisterPageAgentDuringBusinessSubmit_action = () => {
    return RegisterPageSetLoading_promise()
        .then(RegisterPageGenerateCommonPayload_promise)
        .then(RegisterPageValidateDuringBusinessHoursCommonData_promise)
        .then(RegisterPageGenerateAgentPayload_promise)
        .then(RegisterPageAgentValidate_promise)
        .then(RegisterPageGenerateAgentRegistrationPayload_promise)
        .then(RegisterPageSubmitAgentRegistrationForm_promise)
        .catch((Error) => {
            const { ErrorCode, ErrorSource, ErrorMessage } = Error;

            console.log(
                `${ErrorSource} Generated the following error: ${ErrorMessage}`
            );
        })
        .finally(() => RegisterPageClearLoading_promise());
};

const RegisterPageHomebuyerDuringBusinessSubmit_action = () => {
    return RegisterPageSetLoading_promise()
        .then(RegisterPageLeadCreationHomebuyerOnlyGeneratePayload_promise)
        .then(RegisterPageLeadCreationHomebuyerOnlyValidatePayload_promise)
        .then(RegisterPageLeadCreationHomebuyerOnlySubmit_promise)
        .catch((Error) => {
            const { ErrorCode, ErrorSource, ErrorMessage } = Error;

            console.log(
                `${ErrorSource} Generated the following error: ${ErrorMessage}`
            );
        })
        .finally(() => RegisterPageClearLoading_promise());
};

const SFC_AttachSalesCounselor = (name) => {
    $("#SFC_VirtualSalesCounselor").text(name);
    $("#SFC_InPersonSalesCounselor").text(name);
    $("#SFC_VirtualSalesCounselorInfo").text(name);
    $("#SFC_InPersonSalesCounselorInfo").text(name);
};

//const RegisterPageLeadCreationHomebuyerOnlyReroute_promise = (payload) => {
//    return new Promise((resolve, reject) => {
//        const {
//            TourType
//        } = payload;

//        if ($('input[name=tourWithCounselor]:checked').val() === 'counselorY') {
//            if (TourType === "Virtual Tour") {
//                workflow.setTourParty("WS_VT");
//                workflow.stepSelectionCaption = "With sales counselour in virtual tour";
//                resolve(payload);
//            }
//            else if (TourType === "In Person Tour") {
//                workflow.setTourParty("WS_IP");
//                workflow.stepSelectionCaption = "With sales counselour in in person tour";
//                resolve(payload);
//            }
//            else {
//                reject({
//                    ErrorCode: "",
//                    ErrorSource: "RegisterPageLeadCreationHomebuyerOnlyReroute_promise",
//                    ErrorMessage: "Tour type not recognized"
//                });
//            }
//        }
//        else {
//            if (TourType === "Virtual Tour") {
//                workflow.setTourParty("WOS_VT");
//                workflow.stepSelectionCaption = "Without sales counselour in virtual tour";
//                resolve(payload);
//            }
//            else if (TourType === "In Person Tour") {
//                workflow.setTourParty("WOS_IP");
//                workflow.stepSelectionCaption = "Without sales counselour in person tour";
//                resolve(payload);
//            }
//            else {
//                reject({
//                    ErrorCode: "",
//                    ErrorSource: "RegisterPageLeadCreationHomebuyerOnlyReroute_promise",
//                    ErrorMessage: "Tour type not recognized"
//                });
//            }
//        }
//        workflow.renderStep();

//    });
//}

const RegisterPageCreateLeadAgent_action = () => {
    return RegisterPageSetLoading_promise()
        .then(RegisterPageLeadCreationHomebuyerOnlyGeneratePayload_promise)
        .catch((Error) => {
            const { ErrorCode, ErrorSource, ErrorMessage } = Error;

            console.log(
                `${ErrorSource} Generated the following error: ${ErrorMessage}`
            );
        })
        .finally(() => RegisterPageClearLoading_promise());
};

const RegisterPageCreateLeadAgentf_action = () => {
    return new Promise((resolve, reject) => {
        var homeBuyerFirstName = $("#HomebuyerFirstName").val();
        var homeBuyerLastName = $("#HomebuyerLastName").val();
        var homeBuyerEmail = $("#HomebuyerEmailAddress").val();
        var homeBuyerPhone = $("#HomebuyerMobilePhoneNumber").val();

        var payload = {
            FirstName: homeBuyerFirstName,
            LastName: homeBuyerLastName,
            EmailAddress: homeBuyerEmail,

            PhoneNumber: homeBuyerPhone,
            UnderstandTermsPrivacyPolicy: true,
            MetroArea: $("#tour-schedule-metro-area-select").val(),
            Community: $("#tour-schedule-community-select").val(),
            SitecoreItemId: "{4F6F91AB-ABCA-4174-8C8D-2E9C02D5ADF7}",
            ContactListId: $("#salesforce-tour-schedule-form-modal").data(
                "contact-list"
            ),
            TourType: "Self-Guided",
            ContactUserType: "Homebuyer",
            GaClientId: $("#salesforceTourSchedulerGAClientId").val(),
        };

        resolve(payload);
    });
};

//function DuringBusinessHoursSubmit_action() {
//    return TourLockdown_promise()
//        .then(SelfGuidedTourGeneratePayload_promise)
//        .then(SelfGuidedTourLeadValidate_promise)
//        .then(SalesforceSchedulerLeadSubmit_promise)
//        .then(DuringBusinessHoursDisplaySuccessModal_promise)
//        .catch(err => {
//            AddFormLiveValidation();
//            //console.log("DuringBusinessHours_action error");
//            //console.log(err.Message);
//        })
//        .finally(() => TourUnlock_promise())
//}

function DuringBusinessHoursTourCreatePayload_promise() {
    var payload = {
        FirstName: $("#BookATourFirstName").val(),
        LastName: $("#BookATourLastName").val(),
        EmailAddress: $("#BookATourEmail").val(),
        PhoneNumber: $("#BookATourPhone").val(),
        UnderstandTermsPrivacyPolicy: true,
        MetroArea: $("#tour-schedule-metro-area-select").val(),
        Community: $("#tour-schedule-community-select").val(),
        SitecoreItemId: "{4F6F91AB-ABCA-4174-8C8D-2E9C02D5ADF7}",
        ContactListId: $("#salesforce-tour-schedule-form-modal").data(
            "contact-list"
        ),
        TourType: "Self-Guided",
        ContactUserType: "Homebuyer",
        GaClientId: $("#salesforceTourSchedulerGAClientId").val(),
    };

    return payload;
}

const RegisterPageCleanup_action = (payload) => {
    return RegisterPageCleanupInputs(payload);
};

const RegisterPageCleanupInputs = (payload) => {
    return new Promise((resolve, reject) => {
        $("#SFC_HomebuyerCheckbox").empty();
        $("#SFC_AgentCheckbox").empty();

        $("#HomebuyerFirstName").empty();
        $("#HomebuyerLastName").empty();
        $("#HomebuyerEmailAddress").empty();
        $("#HomebuyerMobilePhoneNumber").empty();

        $("#AgentFirstName").empty();
        $("#AgentLastName").empty();
        $("#AgentEmailAddress").empty();
        $("#AgentMobilePhoneNumber").empty();
        $("#AgentAgency").empty();
        $("#AgentZipcode").empty();

        $("#HomebuyerFirstNameError").hide("fast");
        $("#HomebuyerLastNameError").hide("fast");
        $("#HomebuyerEmailAddressError").hide("fast");
        $("#HomebuyerMobilePhoneNumberError").hide("fast");

        $("#AgentFirstNameError").hide("fast");
        $("#AgentLastNameError").hide("fast");
        $("#AgentEmailAddressError").hide("fast");
        $("#AgentMobilePhoneNumberError").hide("fast");
        $("#AgentAgencyError").hide("fast");
        $("#AgentZipcodeError").hide("fast");

        $("#BookATourNotes").empty();

        $("#BookYourTourNow").prop("disabled", true);

        resolve(payload);
    });
};

/************************************************************************************
 *************************** Salesforcescheduler Carousel ***************************
 ************************************************************************************
 */

//function ClearCarouselSelection() {
//    $("#WeekCalendarWrapper").children().each(function () {
//        $(this).children().each(function () {
//            if ($(this).hasClass("CarouselDateCard--selected"))
//                $(this).removeClass("CarouselDateCard--selected");
//            if (!$(this).hasClass("CarouselDateCard--selected"))
//                $(this).addClass("CarouselDateCard");
//        });
//    });
//}

//function InitializeCheckboxSelection() {

//    var AppointmentOnly = ($("#salesforce-tour-schedule-form-modal").data("appointment-only") == "True") ? true : false ;
//    var UTourAvailable = ($("#salesforce-tour-schedule-form-modal").data("self-guided") == "True") ? true : false;
//    var SameDayTour = ($("#salesforce-tour-schedule-form-modal").data("same-day") == "True") ? true : false;

//    if (SameDayTour) {
//        if (!AppointmentOnly && UTourAvailable) {
//            if (!$("#tour_schedule_duringbusinesshours_tour_checkbox").prop("checked")) {
//                $("#tour_schedule_duringbusinesshours_tour_checkbox").prop("checked", true);
//            }
//            RadioStyleClickToggle("tour_schedule_duringbusinesshours_tour_checkbox");
//            TourSchedulerRadioButtonChange("tour_schedule_duringbusinesshours_tour_checkbox");
//        }
//        else if (!AppointmentOnly && !UTourAvailable) {
//            if (!$("#tour_schedule_duringbusinesshours_tour_checkbox").prop("checked")) {
//                $("#tour_schedule_duringbusinesshours_tour_checkbox").prop("checked", true);
//            }
//            RadioStyleClickToggle("tour_schedule_duringbusinesshours_tour_checkbox");
//            TourSchedulerRadioButtonChange("tour_schedule_duringbusinesshours_tour_checkbox");
//        }
//        else if (AppointmentOnly && UTourAvailable) {
//            if (!$("#tour_schedule_extendedhours_tour_checkbox").prop("checked")) {
//                $("#tour_schedule_extendedhours_tour_checkbox").prop("checked", true);
//            }
//            RadioStyleClickToggle("tour_schedule_extendedhours_tour_checkbox");
//            TourSchedulerRadioButtonChange("tour_schedule_extendedhours_tour_checkbox");
//        }
//        if (AppointmentOnly && !UTourAvailable) {
//            $("#SameDayText").html("To schedule a same-day tour, call 844-860-7365");
//            RadioStyleClickToggle("tour_schedule_duringbusinesshours_tour_checkbox");
//            TourSchedulerRadioButtonChange("tour_schedule_duringbusinesshours_tour_checkbox");
//        }
//    }
//    else {
//        if (AppointmentOnly) {
//            if (UTourAvailable && $("#tour_schedule_inperson_tour_checkbox").prop("checked") ||
//                $("#tour_schedule_virtual_tour_checkbox").prop("checked") ||
//                $("#tour_schedule_duringbusinesshours_tour_checkbox").prop("checked")
//            ) {
//                RadioStyleClickToggle("tour_schedule_extendedhours_tour_checkbox");
//                $("#tour_schedule_extendedhours_tour_checkbox").prop("checked", true)
//                TourSchedulerRadioButtonChange("tour_schedule_extendedhours_tour_checkbox");
//            }
//            else
//                TourSchedulerRadioButtonChange("tour_schedule_duringbusinesshours_tour_checkbox");
//        }
//        else {
//            if ($("#tour_schedule_inperson_tour_checkbox").prop("checked")) {
//                TourSchedulerRadioButtonChange("tour_schedule_inperson_tour_checkbox");
//            }
//            else if ($("#tour_schedule_virtual_tour_checkbox").prop("checked")) {
//                TourSchedulerRadioButtonChange("tour_schedule_virtual_tour_checkbox");
//            }
//            else if (UTourAvailable &&
//                $("#tour_schedule_extendedhours_tour_checkbox").prop("checked")) {
//                TourSchedulerRadioButtonChange("tour_schedule_extendedhours_tour_checkbox");
//            }
//            else if ($("#tour_schedule_duringbusinesshours_tour_checkbox").prop("checked")) {
//                TourSchedulerRadioButtonChange("tour_schedule_duringbusinesshours_tour_checkbox");
//            }
//            else {
//                $("#tour_schedule_inperson_tour_checkbox").prop("checked", true);
//                TourSchedulerRadioButtonChange("tour_schedule_inperson_tour_checkbox");
//            }
//        }
//    }
//}

function InitializeDateSelection(startDate, targetDate) {
    //console.log("InitializeDateSelection");
    //console.log("startDate " + startDate);
    //console.log("startDate " + targetDate);
    var differenceInTime = targetDate - startDate;

    var differenceInDays = differenceInTime / (1000 * 3600 * 24);
    var weekIndex = Math.floor(differenceInDays / 7);

    var targetWeek = $("#WeekCalendarWrapper").children()[weekIndex];
    $(document).trigger("CarouselSetActiveSlider", weekIndex);
    var dayIndex = 0;
    let previousID = null;
    let previousSelections = null;
    const externalID = $("#salesforce-tour-schedule-form-modal").data(
        "external-id"
    );

    //console.log("externalID " + externalID);

    var targetDayDate = null;
    let thisCardVal = null;
    let dateCardID = null;
    let dateCardValue = null;
    let currentCard = null;
    $("#" + dateCardID);

    if (differenceInDays == 0) {
        dayIndex = 0;
        targetDayDate = $(targetWeek).children()[dayIndex];
        thisCardVal = $(targetDayDate).data("date-display");
        dateCardID = $(targetDayDate).attr("id");
        dateCardValue = $(targetDayDate).data("date-payload");
        currentCard = $("#" + dateCardID);
        //console.log("currentCard " + currentCard);
        //console.log("dateCardValue " + dateCardValue);
        //console.log("dateCardID " + dateCardID);
        //console.log("thisCardVal " + thisCardVal);
        $("#GuidedTourTimes").empty();
        $("#mth-book-a-tour").data("selected-card", $(targetDayDate).attr("id"));
        $("#" + $(targetDayDate).attr("id")).removeClass("CarouselDateCard");
        $("#" + $(targetDayDate).attr("id")).addClass("CarouselDateCard--selected");
        $("#CarouselSelectedDate").text(thisCardVal);
        $("#" + $(targetDayDate).attr("id")).addClass("TimeSlotSelected");
        $("#salesforce-tour-schedule-form-modal").data("same-day", "True");
        return;
    } else if (differenceInDays < 7) {
        dayIndex = differenceInDays;
        //console.log("dayIndex " + dayIndex);
    } else {
        while (differenceInDays - 7 >= 0) {
            differenceInDays -= 7;
        }
        dayIndex = differenceInDays;
        //console.log("dayIndex " + dayIndex);
    }

    $("#salesforce-tour-schedule-form-modal").data("same-day", "False");

    targetDayDate = $(targetWeek).children()[dayIndex];

    thisCardVal = $(targetDayDate).data("date-display");
    dateCardID = $(targetDayDate).attr("id");
    dateCardValue = $(targetDayDate).data("date-payload");
    currentCard = $("#" + dateCardID);
    $("#GuidedTourTimes").empty();
    previousID = $("#mth-book-a-tour").data("selected-card");
    $("#mth-book-a-tour").data("selected-card", $(targetDayDate).attr("id"));
    $("#" + $(targetDayDate).attr("id")).removeClass("CarouselDateCard");
    $("#" + $(targetDayDate).attr("id")).addClass("CarouselDateCard--selected");
    $("#CarouselSelectedDate").text(thisCardVal);
    $("#" + $(targetDayDate).attr("id")).addClass("TimeSlotSelected");

    if (!$(targetDayDate).prop("disabled")) {
        var payload = {
            CardValue: thisCardVal,
            CardID: dateCardID,
            CardDateValue: dateCardValue,
            PreviousID: previousID,
            PreviousSelection: previousSelections,
            CurrentCard: currentCard,
            CommunityExternalId: externalID,
        };

        //console.log("payload " + payload);
        CarouselDateClick_action(payload);

        var payload = {
            ID: $(targetDayDate).attr("id"),
        };
    }
}

//function InitializeHomebuyerAgentOptions(payload) {
//    return new Promise((resolve, reject) => {
//        $("#tour_schedule_homebuyer_checkbox").prop('disabled', false);
//        $("#tour_schedule_agent_checkbox").prop('disabled', false);
//        resolve(payload);
//    });
//}

//function InitializeMetroEventsAction() {
//    return RetrieveMetroData();
//}

//function InitializeCommunityEventsAction() {
//    return CommunityDropdownReady_promise();
//}

//function InitializeTourModal_action(payload) {

//    return MetroDropdownSetLoading_promise(payload)
//        .then(CommunityDropdownSetLoading_promise)
//        .then(InitializeModalEvents)
//        .then(MetroAreaDropdownInitializeEvent_promise)
//        .then(CommunityDropdownInitializeEvent_promise)
//        .then(InitializeSelfGuidedTourExpandEvent_promise)
//        .then(InitializeNotFindingATime_promise)
//        .then(InitializeError101Modal_promise)
//        .then(InitializeSmartBuyChallangeModal_promise)
//        .then(InitializeDuringBusinessHoursModal_promise)
//        .then(InitializeHomebuyerAgentOptions)
//        .then(InitializeAgentSalesforceTourScheduler_promise)
//        .then(InitializeTourSchedulerRadioEvent_promise)
//        .then(CarouselClearTimesLoading_promise)
//        .catch(errorPayload => {
//            //console.log("InitializeTourModal_action error");
//            //console.log(errorPayload.Message);
//        })
//        .finally(() => {
//        });
//}

//============================================= Initialize Modal End

//============================================= Actions Start ========================================================//

//function RebindCommunity_action(payload) {
//    return CommunityDropdownSetLoading_promise(payload)
//        .then(CommunityDropdownClearData_promise)
//        .then(CommunityDropdownRetrieveData_promise)
//        .then(DropDownSetData_promise)
//        .then(CommunityDropdownReady_promise)
//        .catch(err => {
//            //console.log("RebindCommunity_action: " + err.Message);
//        })
//        .finally(() => {
//        });
//}

//function MetroAreaSelectionChange_action(payload) {
//    return MetroDropdownSetLoading_promise(payload)
//        .then(CommunityDropdownSetLoading_promise)
//        .then(CommunityDropdownClearData_promise)
//        .then(CommunityDropdownRetrieveData_promise)
//        .then(DropDownSetData_promise)
//        .then(CommunityDropdownReady_promise)
//        .then(MetroDropdownSetReady_promise)
//        .catch(err => {
//            //console.log("RebindCommunity_action: " + err.Message);
//        })
//        .finally(() => {
//        });
//}

//============================================= Actions End ========================================================//

//================================================= Time Section Start =======================================//

function SalesforceTourSchedulerTimeClick() {
    let previousID = $("#mth-book-a-tour").data("selected-time");
    let hoursValue = $(this).data("hours-value");
    let currentID = $(this).attr("id");
    $("#mth-book-a-tour").data("selected-time", currentID);

    if (previousID != null) {
        $("#" + previousID).removeClass("TimeSlotSelected");
    }

    let thisCardVal = $(this).data("date-display");

    $(this).addClass("TimeSlotSelected");
    $("#mth-book-a-tour").data("selected-date-time-value", hoursValue);

    if ($(".TimeSlot.TimeSlotSelected").length > 0) {
        $("#SFC_TourSchedulePageBtn").removeClass("hide");

        const month = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];

        let date = new Date(
            $(".CarouselDateCard--selected").attr("data-date-payload")
        );
        let currentDate = date.getDate();

        $(".selected_appointment_date").text(
            month[date.getMonth()] +
            " " +
            currentDate +
            " at " +
            $(".TimeSlot.TimeSlotSelected").text() +
            ""
        );
    }
}

//function SimulateSalesforceTourSchedulerTimeClick(payload) {
//    const {
//        ID,
//    } = payload;

//    let previousID = $("#mth-book-a-tour").data("selected-time");
//    let currentID = ID;

//    if (previousID != null) {
//        $("#" + previousID).removeClass("TimeSlotSelected");
//    }

//    let thisCardVal = $("#" + ID).data("date-display");
//    let dateCardValue = $("#" + ID).data("value");
//    let dateCardID = $("#" + ID).attr("id");

//    $("#mth-book-a-tour").data("selected-card", ID);
//    $("#" + ID).removeClass("CarouselDateCard");
//    $("#" + ID).addClass("CarouselDateCard--selected");
//    $("#CarouselSelectedDate").text(thisCardVal);
//    $("#" + ID).addClass("TimeSlotSelected");
//}

//================================================= Time Section End =======================================//

//=================================================Carousel Section Start =======================================//

//function CarouselDateClick_action(payload) {
//    return CarouselDisable_promise(payload)
//        .then(CarouselSetSelection_promise)
//        .then(CarouselSetTimesLoading_promise)
//        .then(CarouselClearTimesData_promise)
//        .then(CarouselSetDateTitle_promise)
//        .then(CarouselRetrieveTimesDataByDate_promise)
//        .then(CarouselSetTimesData_promise)
//        .catch(error => {
//            //console.log("CarouselDateClick_action: " + error.Message);
//        })
//        .finally(fin =>
//            CarouselClearTimesLoading_promise()
//                .then(CarouselEnable_promise)
//        );
//}

//function CarouselDateClickBypassRetrieval_action(payload) {
//    return CarouselDisable_promise(payload)
//        .then(CarouselSetSelection_promise)
//        .then(CarouselSetTimesLoading_promise)
//        .then(CarouselClearTimesData_promise)
//        .then(CarouselSetTimesData_promise)
//        .catch(error => {
//            //console.log("CarouselDateClick_action: " + error.Message);
//        })
//        .finally(fin =>
//            CarouselClearTimesLoading_promise()
//                .then(CarouselEnable_promise)
//        );
//}

//function CarouselNextWeekClick_action(payload) {
//    return (CarouselSetTimesLoading_promise(payload)
//        .then(CarouselClearTimesData_promise)
//        .then(CarouselClearTimesLoading_promise)
//        .catch(error => {
//            //console.log("CarouselNextWeekClick_action: " + error);
//        })
//        .finally(fin => {
//            //console.log("There was an error on carousel date CarouselNextWeekClick_action")
//        })
//    );
//}

//function CarouselPreviousWeekClick_action(payload) {
//    return (CarouselSetTimesLoading_promise(payload)
//        .then(CarouselClearTimesData_promise)
//        .then(CarouselClearTimesLoading_promise)
//        .catch(error => {
//            //console.log("CarouselPreviousWeekClick_action: " + error);
//        })
//        .finally(fin => {
//            //console.log("There was an error on carousel date CarouselPreviousWeekClick_action")
//        })
//    );
//}

//function CarouselSetTimesLoading_promise(payload) {
//    return new Promise((resolve, reject) => {
//        var guidedTourTimes = $("#GuidedTourTimes");
//        if (guidedTourTimes == null) {
//            reject({ Message: "CarouselSetTimesLoading_promise: Could not find GuidedTourTimes" });
//        }
//        else {
//            $(guidedTourTimes).hide("fast", function () {
//                $("#GuidedTourTimesSpinner").show("fast", function () {
//                    resolve(payload);
//                });
//            });
//        }
//    });
//}

//function CarouselSetTimesData_promise(payload) {
//    return new Promise((resolve, reject) => {

//        var timeArray = payload.Data.availableSlots;

//        var sortedArray = _.sortBy(timeArray, "startHour");

//        $("#GuidedTourTimes").empty();
//        sortedArray.forEach((slot) => {

//            var startHour = slot.startHour;

//            let fullDateValueTime = payload.CardValue;
//            let displayValue = null;
//            if (startHour == 0 || startHour == 24) {
//                fullDateValueTime = fullDateValueTime + "12:00 am";
//                displayValue = "12:00 am";
//            }
//            else if (startHour < 12 && startHour > 0) {
//                fullDateValueTime = fullDateValueTime + startHour + ":00 am";
//                displayValue = startHour + ":00 am";
//            }
//            else if (startHour >= 12 && startHour < 24) {
//                fullDateValueTime = fullDateValueTime + ((startHour - 12 > 0) ? startHour - 12 : 12) + ":00 pm";
//                displayValue = ((startHour - 12 > 0) ? startHour - 12 : 12) + ":00 pm";
//            }
//            else {
//                fullDateValueTime = "INVALID";
//                displayValue = "INVALID";
//            }

//            var TimeSlotPayload = {
//                ID: "TimeSlot" + startHour,
//                DisplayValue: displayValue,
//                FullDate: fullDateValueTime,
//                TimeValue: startHour,
//                DatePayload: payload.CardDateValue
//            };
//            var generatedTimeSlot = SalesforceSchedulerGenerateTimeSlot(TimeSlotPayload);
//            $("#GuidedTourTimes").append(generatedTimeSlot);
//            $("#" + TimeSlotPayload.ID).on("click", SalesforceTourSchedulerTimeClick);

//        });

//        resolve(payload);
//        //}
//    });
//}

//function CarouselClearTimesData_promise(payload) {
//    return new Promise((resolve, reject) => {
//        $("#GuidedTourTimes").empty();
//        resolve(payload);
//    });
//}

//function CarouselClearTimesLoading_promise(payload) {
//    return new Promise((resolve, reject) => {
//        $("#GuidedTourTimesSpinner").hide("fast", function () {
//            $("#GuidedTourTimes").show("fast", function () {
//                resolve(payload);
//            });
//        });
//    });
//}

function CarouselSetSelection_promise(payload) {
    return new Promise((resolve, reject) => {
        if (payload.PreviousID != null && payload.PreviousID != null) {
            $("#" + payload.PreviousID).removeClass("CarouselDateCard--selected");
            $("#" + payload.PreviousID).addClass("CarouselDateCard");
        }

        if (!$(payload.CurrentCard).hasClass("CarouselDateCard--selected"))
            $(payload.CurrentCard).addClass("CarouselDateCard--selected");
        if ($(payload.CurrentCard).hasClass("CarouselDateCard"))
            $(payload.CurrentCard).removeClass("CarouselDateCard");

        $("#mth-book-a-tour").data("selected-card", payload.CardID);
        $("#mth-book-a-tour").data("selected-date", payload.CardDateValue);
        $("#CarouselSelectedDate").text(payload.CardValue);
        resolve(payload);
    });
}
//}

//function CarouselDisable_promise(payload) {
//    return new Promise((resolve, reject) => {

//        $("#mth-book-a-tour").prop("disabled", true);

//        $("#mth-carousel-prev-slider").prop('disabled', true);
//        $("#mth-carousel-next-slider").prop('disabled', true);

//        $("#WeekCalendarWrapper").children().each(function () {
//            $(this).prop('disabled', true);
//            $(this).children().each(function () {
//                $(this).prop('disabled', true);
//            });
//        });
//        resolve(payload);
//    });
//}

//function CarouselEnable_promise(payload) {
//    return new Promise((resolve, reject) => {

//        $("#mth-book-a-tour").prop("disabled", false);

//        $("#mth-carousel-prev-slider").prop('disabled', false);
//        $("#mth-carousel-next-slider").prop('disabled', false);

//        $("#WeekCalendarWrapper").children().each(function () {
//            $(this).prop('disabled', false);
//            $(this).children().each(function () {
//                $(this).prop('disabled', false);
//            });
//        });

//        resolve(payload);
//    });
//}

//function CarouselRetrieveTimesDataByDate_promise(payload) {
//    return new Promise((resolve, reject) => {

//        const bookingDateTime = payload.CardDateValue;;
//        const communityNumber = payload.CommunityExternalId;
//        const salesforceServiceUrl = $("#salesforce-tour-schedule-form-modal").data("salesforce-service-url");

//        $.ajax({
//            url: salesforceServiceUrl + "/" + encodeURIComponent(bookingDateTime) + "/" + communityNumber,
//            method: "GET",
//            success: (function (data) {
//                var responseJson = data;
//                payload.Data = responseJson;
//                resolve(payload);
//            }),
//            error: (function (error) {
//                reject({ Message: "CarouselRetrieveTimesDataByDate_promise: There was a problem retrieving information from the salesforce service\n" });
//            })
//        });
//    });

//}

//function CarouselSetDateTitle_promise(payload) {
//    return new Promise((resolve, reject) => {
//        $("#CarouselSelectedDate").text(payload.DateTitle);
//        resolve(payload);
//    });
//}

//============================================= Community Dropdown Section Start ==============================================================//

//function CommunityDropdownInitializeEvent_promise(payload) {

//    return new Promise((resolve, reject) => {
//        $("#tour-schedule-community-select").on("change", function () {
//            var value = $(this).val();
//            $("#salesforce-tour-schedule-form-modal").data("external-id", value);
//        });

//        resolve(payload);
//    });
//}

//function CommunityDropdownReady_promise(payload) {
//    return new Promise((resolve, reject) => {
//        $("#CommunityFormSpinner").hide();
//        $("#CommunityFormInput").show("slow");
//        $("#tour-schedule-community-select").prop("disabled", true);
//        resolve(payload);
//    });
//}

//function CommunityDropdownSetLoading_promise(payload) {
//    return new Promise((resolve, reject) => {
//        var valid = true;
//        var message = "";
//        var communitySelect = $("#tour-schedule-community-select");
//        var communityFormInput = $("#CommunityFormInput");
//        var communityFormSpinner = $("#CommunityFormSpinner");
//        if (communitySelect == null) {
//            valid = false;
//            message += "CommunityDropdownSetLoading_promise: tour-schedule-community-select not found\n";
//        }
//        if (communityFormInput == null) {
//            valid = false;
//            message += "CommunityDropdownSetLoading_promise: CommunityFormInput not found\n";
//        }
//        if (communityFormSpinner == null) {
//            valid = false;
//            message += "CommunityDropdownSetLoading_promise: CommunityFormSpinner not found\n";
//        }

//        if (valid) {
//            $("#tour-schedule-community-select").prop('disabled', true);
//            $("#CommunityFormInput").hide();
//            $("#CommunityFormSpinner").show("slow");
//            resolve(payload);
//        }
//        else {
//            reject({ Message: message });
//        }
//    });
//}

//function CommunityDropdownRetrieveData_promise(payload) {
//    return new Promise((resolve, reject) => {
//        $.ajax({
//            url: "/api/Sitecore/MetroCommunity/Community?id=" + payload.MetroID,
//            contentType: "application/json;charset=utf-8",
//            method: "GET",
//            complete: (function (data) {
//                var responseJson = data.responseJSON;
//                payload.Data = responseJson;
//                resolve(payload);
//            }),
//            error: (function (error) {
//                reject({ Messsage: "CommunityDropdownRetrieveData_promise: There was an issue retrieving the community dropdown data" });
//            })
//        });
//    });
//}

//function CommunityDropdownClearData_promise(payload) {
//    return new Promise((resolve, reject) => {
//        var metroselect = $(payload.DropDown);
//        metroselect.find('option').first().nextAll().remove();
//        resolve(payload);
//    });
//}

//============================================= Community Dropdown Section Start ==============================================================//

//============================================= Metro Dropdown Section Start ==============================================================//

//function MetroAreaDropdownRebind_action(payload) {
//    return MetroDropdownSetLoading_promise(payload)
//        .then(MetroDropdownClear_promise)
//        .then(MetroDropdownRetrieveData_promise)
//        .then(DropDownSetData_promise)
//        .then(MetroDropdownSetReady_promise);
//}

//function MetroAreaDropdownInitializeEvent_promise(payload) {

//    return new Promise((resolve, reject) => {
//        $('#tour-schedule-metro-area-select').on('change', function () {
//            var value = $(this).val();
//            if (value != '') {
//                var id = value;
//                var payload = {
//                    Type: "Community",
//                    DropDown: $("#tour-schedule-community-select"),
//                    MetroID: id,
//                };
//                return MetroAreaSelectionChange_action(payload);
//            }
//            else {
//                $("#tour-schedule-community-select").prop('disabled', true);
//            }
//        });
//        resolve(payload);
//    });

//}

//function MetroDropdownSetReady_promise(payload) {
//    return new Promise((resolve, reject) => {
//        $("#MetroAreaFormSpinner").hide("fast");
//        $("#MetroAreaFormInput").show("slow");
//        $("#tour-schedule-metro-area-select").prop("disabled", true);

//        resolve(payload);
//    });
//}

//function MetroDropdownSetLoading_promise(payload) {
//    return new Promise((resolve, reject) => {
//        $("#MetroAreaFormSpinner").show("slow");
//        $("#MetroAreaFormInput").hide();
//        resolve(payload);
//    });
//}

//function MetroDropdownRetrieveData_promise(payload) {
//    return new Promise((resolve, reject) => {

//        $.ajax({
//            url: "/api/Sitecore/MetroCommunity/Metro",
//            contentType: "application/json;charset=utf-8",
//            method: "GET",
//            complete: (function (data) {
//                var responseJson = data.responseJSON;
//                payload.Data = responseJson;
//                resolve(payload);
//            })
//        });
//    });
//}

//function MetroDropdownClear_promise(payload) {
//    return new Promise((resolve, reject) => {
//        var metroselect = $('#tour-schedule-metro-area-select');
//        metroselect.find('option').first().nextAll().remove();
//        $(metroselect).empty();
//        resolve(payload);
//    });
//}

//============================================= Metro Dropdown Section End ===============================================================//

//============================================= Dropdown Section Start ==========================================================//

//function DropDownSetData_promise(payload) {
//    return new Promise((resolve, reject) => {

//        var data = payload.Data;
//        var id = null;
//        switch (payload.Type) {
//            case "Metro":
//                id = payload.MetroID;
//                break;
//            case "Community":
//                id = payload.CommunityID;
//                break;
//            default:
//                id = payload.MetroID;
//                break;
//        }

//        var location = payload.DropDown;

//        $.each(_.sortBy(data.areas), function (i, area) {
//            //if (!area.id || !area.displayName) return;

//            if (payload.Type == "Community") {
//                if (area.id == id) {
//                    $("#salesforce-tour-schedule-form-modal").data("external-id", area.externalId);
//                    location.append('<option value="' + area.id + '" data-external-id="' + area.externalId + '" selected="true">' + area.displayName + '</option>');
//                }
//                else {
//                    location.append('<option value="' + area.id + '" data-external-id="' + area.externalId + '">' + area.displayName + '</option>');
//                }
//            }
//            else {
//                if (area.id == id) {
//                    location.append('<option value="' + area.id + '" selected="true">' + area.displayName + '</option>');
//                } else {
//                    location.append('<option value="' + area.id + '">' + area.displayName + '</option>');
//                }
//            }
//        });
//        resolve(payload);
//    });
//}

//============================================= Dropdown Section End ============================================================//

//================================================= Sales Office Data Section Start ==================================//

//function CommunitySalesOfficeInitializeData_action(payload) {
//    return CommunitySalesOfficeSetTimesLoading_promise(payload)
//        .then(CommunitySalesOfficeClearData_promise)
//        .then(CommunitySalesOfficeRetrieveData_promise)
//        .then(CommunitySalesOfficeSetData_promise)
//        .catch(error => {
//            //console.log("Error SalesOfficeDataRebind: " + error);
//        })
//        .finally(() => CommunitySalesOfficeCarouselClearTimesLoading_promise());
//}

//function CommunitySalesOfficeDataBind_action(payload) {
//    return CommunitySalesOfficeSetTimesLoading_promise(payload)
//        .then(CommunitySalesOfficeClearData_promise)
//        .then(CommunitySalesOfficeRetrieveData_promise)
//        .then(CommunitySalesOfficeSetData_promise)
//        .catch(error => {
//            //console.log("Error: CommunitySalesOfficeDataBind_action");
//        })
//        .finally(() => CommunitySalesOfficeCarouselClearTimesLoading_promise());
//}

//function CommunitySalesOfficeDataReBind_action(payload) {
//    return CommunitySalesOfficeDataBind_action(payload)
//        .catch(error => {
//            //console.log("Error: SalesOfficeDataRebind");
//        })
//        .finally(() => CommunitySalesOfficeCarouselClearTimesLoading_promise());
//}

//function CommunitySalesOfficeCarouselClearTimesLoading_promise(payload) {
//    return new Promise((resolve, reject) => {
//        $("#TourSchedulerSalesOfficeHoursSpinner").hide("fast");
//        $("#TourSchedulerSalesOfficeHours").show("slow");
//        resolve(payload);
//    });
//}

//function CommunitySalesOfficeRetrieveData_promise(payload) {
//    return new Promise((resolve, reject) => {
//        $.ajax({
//            url: "/api/Sitecore/SalesOffice/Community?id=" + payload.CommunityID,
//            contentType: "application/json;charset=utf-8",
//            method: "GET",
//            complete: (function (data) {
//                var responseJson = data.responseJSON;
//                payload.Data = responseJson;
//                resolve(payload);
//            }),
//            error: (function (err) {
//                reject("Issue retrieving community sales office data");
//            })
//        });
//    });
//}

//function CommunitySalesOfficeClearData_promise(payload) {
//    return new Promise((resolve, reject) => {
//        $("#TourSchedulerSalesOfficeHours").empty()
//        resolve(payload);
//    });
//}

//function CommunitySalesOfficeSetTimesLoading_promise(payload) {
//    return new Promise((resolve, reject) => {
//        $("#TourSchedulerSalesOfficeHours").hide("fast", function () {
//            $("#TourSchedulerSalesOfficeHoursSpinner").show("slow");
//        });
//        resolve(payload);
//    });
//}

//function CommunitySalesOfficeSetData_promise(payload) {
//    return new Promise((resolve, reject) => {

//        if (payload == null || payload.Data == null || payload.Data.SalesOfficeDays == null) {
//            reject("Issue with setting payload data, one or more variables were null or undefined");
//        }
//        else {
//            $("#TourSchedulerSalesOfficeHours").empty();
//            payload.Data.SalesOfficeDays.forEach(salesOfficeDay => {
//                var SalesOfficeDayDom = "<div id='" + salesOfficeDay.DayOfWeek + "'><label>" + salesOfficeDay.DayOfWeek + ": " + salesOfficeDay.OpenTime + " - " + salesOfficeDay.CloseTime + "</label></div>";
//                $("#TourSchedulerSalesOfficeHours").append(SalesOfficeDayDom);

//            });
//            resolve(payload);

//        }
//    });
//}

//================================================= Sales Office Data Section End ====================================//

//================================================= Tour Type Section Start ==========================================//

//function InitializeTourSchedulerRadioEvent_promise(payload) {
//    return new Promise((resolve, reject) => {
//        $("#DuringBusinessHoursWrapper").hide("fast");
//        $("#ExtendedBusinessHoursWrapper").hide("fast");
//        const {
//            AppointmentOnly,
//            SelfGuidedTourAvailable
//        } = payload;

//        if (AppointmentOnly == "True") {
//            AppointmentOnlyFormEnabled();
//        }
//        else {
//            $("#LikeToTour").show("fast");
//            GuidedTourToggle(true);
//            DuringBusinessHoursTourToggle(true);
//            if (SelfGuidedTourAvailable == "True") {
//                SelfGuidedTourToggle(true);
//            }
//            else {
//                SelfGuidedTourToggle(false);
//            }
//        }

//        resolve(payload);
//    });
//}

//function InitializeSmartBuyChallangeModal_promise(payload) {
//    return new Promise((resolve, reject) => {
//        $("#SmartBuyModalClose").on("click", function () {
//            $('#salesforce-tour-schedule-form-modal').foundation('close');
//            $("#SmartBuyModalWrapper").css({ "display": "none" });
//            $("#SmartBuyModalWrapper").css({ "min-height": "unset" });
//            CleanupDataAttributes();
//        });
//        resolve(payload)
//    });
//}

//function InitializeDuringBusinessHoursModal_promise(payload) {
//    return new Promise((resolve, reject) => {
//        $("#DuringBusinessHoursClose").on("click", function () {
//            $('#salesforce-tour-schedule-form-modal').foundation('close');
//            $("#DuringBusinessHoursModalWrapper").css({ "display": "none" });
//            CleanupDataAttributes();
//        });
//        resolve(payload)
//    });
//}

//function InitializeError101Modal_promise(payload) {
//    return new Promise((resolve, reject) => {
//        $("#Error101Close").on("click", function () {
//            $("#SalesforceTourSchedulerError101Wrapper").css({ "display": "none" });
//            $("#SalesforceTourSchedulerError101").hide("fast");
//        });
//        resolve(payload)
//    });
//}

//function InitializeSelfGuidedTourExpandEvent_promise(payload) {
//    return new Promise((resolve, reject) => {

//        if ($("#salesforce-tour-schedule-form-modal").data("self-guided") == "True") {
//            $("#tour_schedule_extendedhours_tour_checkbox").prop("disabled", false);
//            $("#ExtendedBusinessHoursWrapper").prop("disabled", false);
//            $("#tour_schedule_extendedhours_tour_checkbox").show();

//            $("#SelfGuidedTourExpand").on("click", function () {
//                var toggle = $(this).data("open");
//                if (toggle == undefined) {
//                    $(this).data("open", false);
//                    $("#SelfGuidedTourExpandedDescriptionWrapper").css({ "display": "none" });
//                    $("#SelfGuidedTourExpandedDescription").hide("fast");
//                }
//                else if (toggle == true) {
//                    $(this).data("open", false);
//                    $("#SelfGuidedTourExpandedDescriptionWrapper").css({ "display": "none" });
//                    $("#SelfGuidedTourExpandedDescription").hide("fast");

//                }
//                else {
//                    $(this).data("open", true);
//                    $("#SelfGuidedTourExpandedDescriptionWrapper").css({ "display": "unset" });
//                    $("#SelfGuidedTourExpandedDescription").show("fast");
//                }
//            });

//            $("#SelfGuidedTourExpandedDescriptionClose").on("click", function () {
//                $("#SelfGuidedTourExpandedDescription").hide();
//                $("#SelfGuidedTourExpandedDescriptionWrapper").css({ "display": "none" });
//                $("#SelfGuidedTourExpand").data("open", false);
//            });

//            $("#SelfGuidedTourExpandedDescription").hide("fast");
//        }
//        else {
//            $("#tour_schedule_extendedhours_tour_checkbox").prop("disabled", true);
//            $("#tour_schedule_extendedhours_tour_checkbox").hide();
//            $("#ExtendedBusinessHoursWrapper").prop("disabled", true);
//            $("#ExtendedBusinessHoursWrapper").hide();
//            //$("#SelfGuidedTourExpand").off("click");
//        }
//        resolve(payload);
//    });
//}

//function TourSchedulerRadioButtonChange(origin) {

//    var AppointmentOnly = ($("#salesforce-tour-schedule-form-modal").data("appointment-only") == "True") ? true : false;
//    var UTourAvailable = ($("#salesforce-tour-schedule-form-modal").data("self-guided") == "True") ? true : false;
//    var SameDayTour = ($("#salesforce-tour-schedule-form-modal").data("same-day") == "True") ? true : false;

//    $("#BookYourTourNow").unbind("click");
//    if (SameDayTour) {
//        if (!AppointmentOnly && UTourAvailable) {
//            $("#SameDayText").html("For same-day tours, call 844-860-7365 or stop by our sales office during business hours. Walk-ins are welcome. Choose <b>extended hours</b> for more options.");

//            SalesforceTourCarouselToggle(true);

//            if (origin != "tour_schedule_extendedhours_tour_checkbox") {
//                $("#" + origin).prop("checked", false);
//                $("#tour_schedule_duringbusinesshours_tour_checkbox").prop("checked", true);
//                RadioStyleClickToggle("tour_schedule_duringbusinesshours_tour_checkbox");
//                SalesforceTourFormToggle(true);
//                DuringBusinessHoursTourChange();
//                var tourSchedulerSalesOfficeHoursDOM = document.getElementById("TourSchedulerSalesOfficeHours");
//                tourSchedulerSalesOfficeHoursDOM.scrollIntoView({ behavior: "smooth" });
//            }
//            else if (origin == "tour_schedule_extendedhours_tour_checkbox") {
//                RadioStyleClickToggle("tour_schedule_extendedhours_tour_checkbox");
//                SalesforceTourFormToggle(false);
//                DuringBusinessHoursTourDisplayToggle(false);
//                SelfGuidedTourCheckboxToggle(true);
//                var tourSchedulerUTOUR = document.getElementById("tour_schedule_extendedhours_tour_checkbox");
//                tourSchedulerUTOUR.scrollIntoView({ behavior: "smooth" });
//            }
//            else if (origin == "tour_schedule_duringbusinesshours_tour_checkbox") {
//                RadioStyleClickToggle("tour_schedule_duringbusinesshours_tour_checkbox");
//                SalesforceTourFormToggle(true);
//                SalesforceTourCarouselToggle(true);
//                DuringBusinessHoursTourChange();

//            }
//        }
//        else if (!AppointmentOnly && !UTourAvailable) {
//            $("#SameDayText").html("For same-day tours, call 844-860-7365 or visit our sales office. Walk-ins are always welcome.");
//            if (!$("#tour_schedule_duringbusinesshours_tour_checkbox").prop("checked")) {
//                $("#tour_schedule_duringbusinesshours_tour_checkbox").prop("checked", true);
//                RadioStyleClickToggle("tour_schedule_duringbusinesshours_tour_checkbox");
//                SalesforceTourFormToggle(true);
//                SalesforceTourCarouselToggle(true);
//                DuringBusinessHoursTourChange();
//                var tourSchedulerSalesOfficeHoursDOM = document.getElementById("TourSchedulerSalesOfficeHours");
//                tourSchedulerSalesOfficeHoursDOM.scrollIntoView({ behavior: "smooth" });
//            }
//            else {
//                DuringBusinessHoursTourChange();
//            }
//        }
//        else if (AppointmentOnly && UTourAvailable) {
//            $("#SameDayText").html("To schedule a same-day tour, call 844-860-7365 or select <b>extended hours</b> for additional self-guided tour options. ");
//            if (!$("#tour_schedule_extendedhours_tour_checkbox").prop("checked")) {
//                $("#tour_schedule_extendedhours_tour_checkbox").prop("checked", true);
//                RadioStyleClickToggle("tour_schedule_extendedhours_tour_checkbox");
//                var tourSchedulerUTOUR = document.getElementById("tour_schedule_extendedhours_tour_checkbox");
//                tourSchedulerUTOUR.scrollIntoView({ behavior: "smooth" });
//            }
//            SalesforceTourFormToggle(false);
//            SalesforceTourCarouselToggle(true);
//            DuringBusinessHoursTourDisplayToggle(false);
//            SelfGuidedTourCheckboxToggle(true);
//        }
//        else if (AppointmentOnly && !UTourAvailable) {
//            SalesforceTourFormToggle(false);
//            SalesforceTourCarouselToggle(true);
//            $("#SameDayText").html("To schedule a same-day tour, call 844-860-7365");
//        }
//        ToggleTodayView(true);
//    }
//    else {
//        if (AppointmentOnly) {
//            AppointmentOnlyFormEnabled();
//            GuidedTourDisplay(false);
//            if (UTourAvailable) {
//                if (!$("#tour_schedule_extendedhours_tour_checkbox").prop("checked")) {
//                    $("#tour_schedule_extendedhours_tour_checkbox").prop("checked", true);
//                    RadioStyleClickToggle("tour_schedule_extendedhours_tour_checkbox");
//                }
//                SalesforceTourFormToggle(false);
//                SalesforceTourCarouselToggle(true);
//                RadioStyleClickToggle("tour_schedule_extendedhours_tour_checkbox");
//                ExtendedHoursTourChange();
//            }
//        }
//        else {
//            GuidedTourDisplay(true);
//            if (origin == "tour_schedule_virtual_tour_checkbox") {
//                SalesforceTourFormToggle(true);
//                SalesforceTourCarouselToggle(true);
//                RadioStyleClickToggle("tour_schedule_virtual_tour_checkbox");
//                VirtualTourChange();
//            }
//            else if (origin == "tour_schedule_inperson_tour_checkbox") {
//                SalesforceTourFormToggle(true);
//                SalesforceTourCarouselToggle(true);
//                RadioStyleClickToggle("tour_schedule_inperson_tour_checkbox");
//                GuidedTourChange();
//            }
//            else if (origin == "tour_schedule_duringbusinesshours_tour_checkbox") {
//                SalesforceTourFormToggle(true);
//                SalesforceTourCarouselToggle(true);
//                RadioStyleClickToggle("tour_schedule_duringbusinesshours_tour_checkbox");
//                DuringBusinessHoursTourChange();
//            }
//            else if (origin == "tour_schedule_extendedhours_tour_checkbox" && UTourAvailable) {
//                SalesforceTourFormToggle(false);
//                SalesforceTourCarouselToggle(true);
//                RadioStyleClickToggle("tour_schedule_extendedhours_tour_checkbox");
//                ExtendedHoursTourChange();
//            }

//        }
//        ToggleTodayView(false);
//    }
//}

//function DuringBusinessHoursTourChange() {
//    GuidedTourDisplay(false);
//    SelfGuidedTourCheckboxToggle(false);
//    DuringBusinessHoursTourDisplayToggle(true);

//    $("#TourSchedulerSalesOfficeHoursSpinner").hide();
//    $("#TourSchedulerSalesOfficeHours").show();

//    $("#BookYourTourNow").text("Sign Up For More Info");
//    $("#NotFindingATime").hide();
//    $("#BookYourTourNow").on("click", function (event) {
//        event.preventDefault();
//        if ($(this).data('verified') == false) {
//            ShowSalesforceRecaptchaError();
//            $(this).prop("disabled", true);
//        }
//        else {
//            HideSalesforceRecaptchaError();
//            DuringBusinessHoursSubmit_action();
//        }
//    });
//}

//function GuidedTourChange() {
//    SelfGuidedTourCheckboxToggle(false);
//    DuringBusinessHoursTourDisplayToggle(false);
//    GuidedTourDisplay(true);

//    $("#BookYourTourNow").text("Book Your Tour Now");
//    $("#NotFindingATime").show();
//    $("#BookYourTourNow").on("click", function () {
//        event.preventDefault();
//        if ($(this).data('verified') == false) {
//            ShowSalesforceRecaptchaError();
//            $(this).prop("disabled", true);
//        }
//        else {
//            HideSalesforceRecaptchaError();
//            SubmitGuidedTourBooking_action();
//        }
//    });
//}

//function VirtualTourChange() {

//    SelfGuidedTourCheckboxToggle(false);
//    DuringBusinessHoursTourDisplayToggle(false);
//    GuidedTourDisplay(true);

//    $("#BookYourTourNow").text("Book Your Tour Now");
//    $("#NotFindingATime").show();
//    $("#BookYourTourNow").on("click", function () {
//        event.preventDefault();
//        if ($(this).prop('data-verified') == false) {
//            ShowSalesforceRecaptchaError();
//            $(this).prop("disabled", true);
//        }
//        else {
//            HideSalesforceRecaptchaError();
//            SubmitGuidedTourBooking_action();
//        }
//    });
//}

//function ExtendedHoursTourChange() {
//    DuringBusinessHoursTourDisplayToggle(false);
//    SelfGuidedTourCheckboxToggle(true);
//}

//function FindCurrentRadioSelection() {
//    if ($("#tour_schedule_extendedhours_tour_checkbox").prop("checked"))
//        return "tour_schedule_extendedhours_tour_checkbox";
//    else if ($("#tour_schedule_duringbusinesshours_tour_checkbox").prop("checked"))
//        return "tour_schedule_duringbusinesshours_tour_checkbox";
//    else if ($("#tour_schedule_inperson_tour_checkbox").prop("checked"))
//        return "tour_schedule_inperson_tour_checkbox";
//    else if ($("#tour_schedule_virtual_tour_checkbox").prop("checked"))
//        return "tour_schedule_virtual_tour_checkbox";
//}

//function RadioStyleClickToggle(origin) {

//    var checkboxArray = [
//        "#VirtualTourRadioWrapper",
//        "#InPersonTourRadioWrapper",
//        "#SalesforceSchedulerduringBusinessHoursRadioWrapper",
//        "#SalesforceTourSchedulerRadioWrapper",
//    ];

//    var target = null;
//    switch (origin) {
//        case "tour_schedule_virtual_tour_checkbox":
//            target = checkboxArray[0];
//            checkboxArray.splice(0, 1);
//            break;
//        case "tour_schedule_inperson_tour_checkbox":
//            target = checkboxArray[1];
//            checkboxArray.splice(1, 1);
//            break;
//        case "tour_schedule_duringbusinesshours_tour_checkbox":
//            target = checkboxArray[2];
//            checkboxArray.splice(2, 1);
//            break;
//        case "tour_schedule_extendedhours_tour_checkbox":
//            target = checkboxArray[3];
//            checkboxArray.splice(3, 1);
//            break;
//    }

//    if (target != null) {
//        if (!$(target).hasClass("TourCheckboxSelected"))
//            $(target).addClass("TourCheckboxSelected")
//        if ($(target).hasClass("TourCheckbox"))
//            $(target).removeClass("TourCheckbox")
//    }

//    checkboxArray.forEach(checkbox => {
//        if ($(checkbox).hasClass("TourCheckboxSelected"))
//            $(checkbox).removeClass("TourCheckboxSelected")
//        if (!$(checkbox).hasClass("TourCheckbox"))
//            $(checkbox).addClass("TourCheckbox")
//    });

//    switch (origin) {
//        case "tour_schedule_virtual_tour_checkbox":

//            $("#InPersonTourRadioWrapper").removeClass("TourCheckboxSelected")
//            $("#tour_schedule_duringbusinesshours_tour_checkbox").removeClass("TourCheckbox")
//            $("#tour_schedule_extendedhours_tour_checkbox").removeClass("TourCheckbox")
//            if (!$("#tour_schedule_virtual_tour_checkbox").hasClass("TourCheckboxSelected")) {
//                $("#tour_schedule_virtual_tour_checkbox").addClass("TourCheckboxSelected")
//            }
//            $("#tour_schedule_virtual_tour_checkbox").removeClass("TourCheckbox")
//            break;
//        case "tour_schedule_inperson_tour_checkbox":
//            $("#tour_schedule_virtual_tour_checkbox").removeClass("TourCheckbox")
//            $("#tour_schedule_duringbusinesshours_tour_checkbox").removeClass("TourCheckbox")
//            $("#tour_schedule_extendedhours_tour_checkbox").removeClass("TourCheckbox")
//            if (!$("#tour_schedule_inperson_tour_checkbox").hasClass("TourCheckboxSelected")) {
//                $("#tour_schedule_inperson_tour_checkbox").addClass("TourCheckboxSelected")
//            }
//            $("#tour_schedule_inperson_tour_checkbox").removeClass("TourCheckbox")
//            break;
//        case "tour_schedule_duringbusinesshours_tour_checkbox":
//            $("#tour_schedule_virtual_tour_checkbox").removeClass("TourCheckbox")
//            $("#tour_schedule_inperson_tour_checkbox").removeClass("TourCheckbox")
//            $("#tour_schedule_extendedhours_tour_checkbox").removeClass("TourCheckbox")
//            if (!$("#tour_schedule_duringbusinesshours_tour_checkbox").hasClass("TourCheckboxSelected")) {
//                $("#tour_schedule_duringbusinesshours_tour_checkbox").addClass("TourCheckboxSelected")
//            }
//            $("#tour_schedule_duringbusinesshours_tour_checkbox").removeClass("TourCheckbox")
//            break;
//        case "tour_schedule_extendedhours_tour_checkbox":
//            $("#tour_schedule_virtual_tour_checkbox").removeClass("TourCheckbox")
//            $("#tour_schedule_inperson_tour_checkbox").removeClass("TourCheckbox")
//            $("#tour_schedule_duringbusinesshours_tour_checkbox").removeClass("TourCheckbox")
//            if (!$("#tour_schedule_extendedhours_tour_checkbox").hasClass("TourCheckboxSelected")) {
//                $("#tour_schedule_extendedhours_tour_checkbox").addClass("TourCheckboxSelected")
//            }
//            $("#tour_schedule_extendedhours_tour_checkbox").removeClass("TourCheckbox")
//            break;
//    }
//}

//function GuidedTourDisplay(toggle) {

//    var AppointmentOnly = $("#salesforce-tour-schedule-form-modal").data("appointment-only");

//    if (AppointmentOnly == "True") {
//        AppointmentOnlyFormEnabled();
//    }
//    else if (AppointmentOnly != "True" && toggle) {
//        $("#GuidedTourWorkArea").show("fast");
//        $("#NotFindingATime").show("fast");
//        $("#CarouselWrapper").show("fast");
//        $("#GuidedTourCheckboxes").show("fast");
//        $("#SalesforceSchedulerBorder").show("fast");
//    }
//    else {
//        $("#GuidedTourWorkArea").hide("fast");
//        $("#NotFindingATime").hide("fast");
//        $("#GuidedTour").hide("fast");
//        $("#SalesforceSchedulerBorder").hide("fast");
//    }
//}

//function DuringBusinessHoursTourDisplayToggle(toggle) {
//    if (toggle) {
//        if ($("#TourSchedulerSalesOfficeHoursSpinner").is(":visible")) {
//            $("#TourSchedulerSalesOfficeHoursSpinner").hide();
//        }
//        $("#DuringBusinessHoursWrapper").show("fast");
//        $("#TourSchedulerSalesOfficeHours").show("fast");
//        SalesforceTourFormToggle(true);
//        SalesforceTourCarouselToggle(true);
//    }
//    else {
//        $("#DuringBusinessHoursWrapper").hide("fast");
//        $("#TourSchedulerSalesOfficeHours").hide("fast");
//    }
//}

//function SelfGuidedTourCheckboxToggle(toggle) {
//    var SameDayTour = ($("#salesforce-tour-schedule-form-modal").data("same-day") == "True") ? true : false;

//    if (SameDayTour)
//        $("#LikeToTour").hide("fast");
//    else
//        $("#LikeToTour").show("fast");
//    if (toggle) {
//        $("#ExtendedBusinessHoursWrapper").show("fast");
//        $("#SelfGuidedTourExpand").data("open", false);
//        $("#GuidedTourWorkArea").hide("fast");
//        $("#NotFindingATime").hide("fast");
//        $("#BookYourTourNow").unbind("click");
//    }
//    else {
//        $("#ExtendedBusinessHoursWrapper").hide("fast");
//        $("#SelfGuidedTourExpand").data("open", false);

//    }
//}

//================================================= Tour Type Section End   ==========================================//

//================================================= Form Posting Section Start =======================================//

//function InitializeNotFindingATime_promise(payload) {

//    return new Promise((resolve, reject) => {
//        var notFindingATime = document.getElementById("NotFindingATime");

//        if (notFindingATime == null) {
//            reject({ Message: "InitializeNotFindingATime_promise: There was a problem initializing NotFindingATime" });
//        }
//        else {
//            $("#NotFindingATime").on("click", function () {
//                $("#tour_schedule_duringbusinesshours_tour_checkbox").prop("checked", true);
//                TourSchedulerRadioButtonChange("tour_schedule_duringbusinesshours_tour_checkbox");
//                var tourSchedulerSalesOfficeHoursDOM = document.getElementById("TourSchedulerSalesOfficeHours");
//                tourSchedulerSalesOfficeHoursDOM.scrollIntoView({ behavior: "smooth" });
//            });
//            resolve(payload);
//        }
//    });
//}

//function GuidedTourGeneratePayload_promise() {

//    return new Promise((resolve, reject) => {
//        var createPayload = GuidedTourGeneratePayload();
//        resolve(createPayload);
//    });
//}

//function GuidedTourGenerateLeadPayload_promise() {

//    return new Promise((resolve, reject) => {
//        var createPayload = GuidedTourGenerateLeadPayload();
//        resolve(createPayload);
//    });
//}

//function GuidedTourSubmitAppointment_promise(payload) {

//    return new Promise((resolve, reject) => {
//        const salesforceServiceUrl = $("#salesforce-tour-schedule-form-modal").data("salesforce-service-url");
//        if (payload == null) {
//            reject({ Message: "GuidedTourSubmitAppointment_promise: There was a problem generaqting the data payload" });
//        }
//        else {
//            $.ajax({
//                method: "POST",
//                url: salesforceServiceUrl + "/SubmitAppointment",
//                contentType: "application/json; charset=utf-8",
//                data: JSON.stringify(payload),
//                success: (function (data) {
//                    var responseJson = data;
//                    if (Array.isArray(responseJson.appointmentBookingResult) && responseJson.appointmentBookingResult.length > 0) {
//                        if (responseJson.appointmentBookingResult[0].errorCode != null && responseJson.appointmentBookingResult[0].errorCode != 0) {
//                            reject({ ErrorCode: responseJson.appointmentBookingResult[0].errorCode });
//                        }
//                        else {
//                            resolve(payload);
//                        }
//                    }
//                }),
//            });
//        }
//    });
//}

//function GuidedTourDisplaySuccessModal_promise(payload) {
//    return new Promise((resolve, reject) => {
//        if ($("#tour_schedule_inperson_tour_checkbox").prop("checked")) {
//            $("#SmartBuyModalThankYou").text("Thanks for booking an in-person tour with a Meritage Homes Sales Counselor. We'll send you a confirmation email shortly.");
//        }
//        else if ($("#tour_schedule_virtual_tour_checkbox").prop("checked")) {
//            $("#SmartBuyModalThankYou").text("Thanks for booking a virtual tour with a Meritage Homes Sales Counselor. We'll send you a confirmation email shortly.");
//        }
//        $("#SmartBuyModalWrapper").css({ "display": "unset" });
//        $("#SmartBuyModalWrapper").css({ "min-height": "150px" });
//        $("#SmartBuyModal").show();
//        resolve(payload)
//    });
//}

//function GuidedTourValidateLeadPayload_promise(payload) {
//    return new Promise((resolve, reject) => {
//        const {
//            FirstName,
//            LastName,
//            EmailAddress,
//            PhoneNumber,
//            UnderstandTermsPrivacyPolicy,
//            MetroArea,
//            Community,
//            TourType,
//            ContactUserType
//        } = payload;

//        var valid = true;
//        var errorMessage = "";
//        const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
//        const emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.+[a-zA-Z0-9.]/;

//        $("#SalesforceSubmitErrors").html("");

//        if (FirstName == null || FirstName == "") {
//            valid = false;
//            errorMessage += "First Name was missing <br>";
//            $("#BookATourFirstNameError").show("slow");
//        }
//        else {
//            $("#BookATourFirstNameError").hide("slow");
//        }
//        if (LastName == null || LastName == "") {
//            valid = false;
//            errorMessage += "Last Name was missing<br>";
//            $("#BookATourLastNameError").show("slow");
//        }
//        else {
//            $("#BookATourLastNameError").hide("slow");
//        }

//        if (EmailAddress == null || EmailAddress == "") {
//            valid = false;
//            rejectedMessage += "Please enter Email/n";
//            $("#BookATourEmailError").show("slow");
//        }
//        else {
//            if (!emailRegex.test(EmailAddress)) {
//                valid = false;
//                rejectedMessage += "Error validating email/n";
//                $("#BookATourEmailError").show("slow");
//            }
//            $("#BookATourEmailError").hide("slow");
//        }

//        if (PhoneNumber == null || PhoneNumber == "") {
//            valid = false;
//            errorMessage = errorMessage.concat("Error validating phone.\n");
//            $("#BookATourPhoneNumberError").show("slow");
//        }
//        else {
//            if (!phoneRegex.test(PhoneNumber)) {
//                valid = false;
//                errorMessage = errorMessage.concat("Error validating phone.\n");
//                $("#BookATourPhoneNumberError").show("slow");
//            }
//            else {
//                $("#BookATourPhoneNumberError").hide("slow");
//            }
//        }
//        if (MetroArea == null || MetroArea == "") {
//            valid = false;
//            errorMessage += "Metro Area was missing<br>";
//        }
//        if (Community == null || Community == "") {
//            valid = false;
//            errorMessage += "Community was missing<br>";
//        }
//        if (TourType == null || TourType == "") {
//            valid = false;
//            errorMessage += "Tour Type was missing<br>";
//        }
//        if (ContactUserType == null || ContactUserType == "") {
//            valid = false;
//            errorMessage += "Contact User was missing<br>";
//        }
//        if (UnderstandTermsPrivacyPolicy == null || ContactUserType == "") {
//            valid = false;
//        }

//        valid = (!$("#TourForm")[0].checkValidity()) ? false : valid;
//        valid = (!$("#NotFindingATime").is(":visible")) ? false : valid;

//        if (valid) {
//            resolve(payload);
//        }
//        else {
//            $("#SalesforceSubmitErrors").html(errorMessage);
//            reject({ Message: "GuidedTourValidatePayload_promise:<br>" + errorMessage });
//        }

//    });
//}

//function GuidedTourValidatePayload_promise(payload) {
//    return new Promise((resolve, reject) => {

//        const {
//            appointmentBookingRequest
//        } = payload;

//        if (appointmentBookingRequest == null) {
//            reject({ Message: "GuidedTourValidatePayload_promise: error in appointment booking request" });
//        }

//        const {
//            appointmentType,
//            bookingDate,
//            bookingHour,
//            communityNumber,
//            email,
//            firstName,
//            lastName,
//            notes,
//            phone
//        } = appointmentBookingRequest;

//        const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
//        const emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.+[a-zA-Z0-9.]/;

//        var valid = true;
//        var rejectedMessage = "GuidedTourValidatePayload_promise: ";

//        if (firstName == null || firstName == "") {
//            valid = false;
//            rejectedMessage += "Please enter First Name/n";
//            $("#BookATourFirstNameError").show("slow");
//        }
//        else {
//            $("#BookATourFirstNameError").hide("slow");
//        }
//        if (lastName == null || lastName == "") {
//            valid = false;
//            rejectedMessage += "Please enter Last Name/n";
//            $("#BookATourLastNameError").show("slow");
//        }
//        else {
//            $("#BookATourLastNameError").hide("slow");
//        }
//        if (email == null || email == "") {
//            valid = false;
//            rejectedMessage += "Please enter Email/n";
//            $("#BookATourEmailError").show("slow");
//        }
//        else {
//            if (!emailRegex.test(email)) {
//                valid = false;
//                rejectedMessage += "Error validating email/n";
//                $("#BookATourEmailError").show("slow");
//            }
//            $("#BookATourEmailError").hide("slow");
//        }
//        if (phone == null || phone == "") {
//            valid = false;
//            rejectedMessage.concat("Error validating phone.\n");
//            $("#BookATourPhoneNumberError").show("slow");
//        }
//        else {
//            if (!phoneRegex.test(phone)) {
//                valid = false;
//                rejectedMessage.concat("Error validating phone.\n");
//                $("#BookATourPhoneNumberError").show("slow");
//            }
//            else {
//                $("#BookATourPhoneNumberError").hide("slow");
//            }
//        }
//        if (bookingHour == null || bookingHour == "") {
//            valid = false;
//            rejectedMessage += "No time was selected/n";
//        }
//        if (bookingDate == null || bookingDate == "") {
//            valid = false;
//            rejectedMessage += "No date was selected/n";
//        }
//        if (communityNumber == null || communityNumber == "") {
//            valid = false;
//            rejectedMessage += "Community external id was not found/n";
//        }
//        if (appointmentType == null || appointmentType == "") {
//            valid = false;
//            rejectedMessage += "Appointment type not set/n";
//        }

//        valid = (!$("#TourForm")[0].checkValidity()) ? false : valid;
//        if (valid) {
//            resolve(payload);
//        }
//        else {
//            reject({ Message: rejectedMessage });
//        }
//    });
//}

//function GuidedTourGenerateLeadPayload() {
//    var payload = {
//        "FirstName": $("#BookATourFirstName").val(),
//        "LastName": $("#BookATourLastName").val(),
//        "EmailAddress": $("#BookATourEmail").val(),
//        "PhoneNumber": $("#BookATourPhone").val(),
//        "UnderstandTermsPrivacyPolicy": true,
//        "MetroArea": $("#tour-schedule-metro-area-select").val(),
//        "Community": $("#tour-schedule-community-select").val(),
//        "TourType": ($("tour_schedule_virtual_tour_checkbox").prop("checked")) ? "Virtual Tour" : "In Person Tour",
//        "SitecoreItemId": "{4F6F91AB-ABCA-4174-8C8D-2E9C02D5ADF7",
//        "ContactListId": $("#salesforce-tour-schedule-form-modal").data("contact-list"),
//        "ContactUserType": "Homebuyer"
//    };

//    return payload;
//}

//function GuidedTourGeneratePayload() {
//    var firstName = $("#BookATourFirstName").val();
//    var lastName = $("#BookATourLastName").val();
//    var email = $("#BookATourEmail").val();
//    var phoneNumber = $("#BookATourPhone").val();
//    var notes = $("#BookATourNotes").val();
//    var tourType = ($("#tour_schedule_virtual_tour_checkbox").prop("checked")) ? "Virtual Tour" : "In Person Tour";
//    var communityExternalID = $("#salesforce-tour-schedule-form-modal").data("external-id");
//    var bookingDate = $("#mth-book-a-tour").data("selected-date");
//    var bookingHour = $("#mth-book-a-tour").data("selected-date-time-value");

//    var payload = {
//        "appointmentBookingRequest":
//        {
//            "communityNumber": communityExternalID,
//            "bookingDate": bookingDate,
//            "bookingHour": bookingHour,
//            "firstName": firstName,
//            "lastName": lastName,
//            "phone": phoneNumber,
//            "email": email,
//            "appointmentType": tourType,
//            "notes": notes,
//            "gaClientId": $("#salesforceTourSchedulerGAClientId").val()
//        }

//    };

//    return payload;
//}

//function SubmitGuidedTourBooking_action() {
//    return TourLockdown_promise()
//        .then(CarouselDisable_promise)
//        .then(GuidedTourGeneratePayload_promise)
//        .then(GuidedTourValidatePayload_promise)
//        .then(GuidedTourSubmitAppointment_promise)
//        .then(GuidedTourDisplaySuccessModal_promise)
//        .catch(err => {
//            //console.log("Error detected Code: ");
//            //console.log(err);
//            AddFormLiveValidation();
//            if (err != null && err.ErrorCode != null) {

//                switch (err.ErrorCode) {
//                    case 101:
//                        //console.log("Error detected" + err.ErrorCode);

//                        var selectedCard = $("#mth-book-a-tour").data("selected-card");
//                        var dateCardValue = $("#" + selectedCard).data("date-payload");
//                        var dateCardID = $("#" + selectedCard).attr("id");
//                        var thisCardVal = $("#" + selectedCard).data("date-display");
//                        const externalID = $("#salesforce-tour-schedule-form-modal").data("external-id");
//                        var currentCard = $("#" + selectedCard);

//                        var payload = {
//                            CardValue: thisCardVal,
//                            CardID: dateCardID,
//                            CardDateValue = dateCardValue,
//                            PreviousID = null,
//                            PreviousSelection = null,
//                            CurrentCard = currentCard,
//                            CommunityExternalId: externalID
//                        }

//                        GuidedTourBookingErrorHandles101(payload);
//                        break;
//                    default:
//                        //console.log("SubmitGuidedTourBooking_action Error: " + err.Message);
//                }
//            }
//            else {
//                //console.log("SubmitGuidedTourBooking_action Error: " + err.Message);
//            }
//        })
//        .finally(() =>
//            TourUnlock_promise()
//                .then(CarouselEnable_promise)
//        )
//}

//function GuidedTourBookingErrorHandles101(payload) {
//    return CarouselDisable_promise(payload)
//        .then(SalesforceSchedulerError101DisplayModal_promise)
//        .then(CarouselSetSelection_promise)
//        .then(CarouselSetTimesLoading_promise)
//        .then(CarouselClearTimesData_promise)
//        .then(CarouselSetDateTitle_promise)
//        .then(CarouselRetrieveTimesDataByDate_promise)
//        .then(CarouselSetTimesData_promise)
//        .catch(error => {
//            //console.log("GuidedTourBookingErrorHandles101:" + error.ErrorMessage);
//        })
//        .finally(() =>
//            TourUnlock_promise()
//                .then(CarouselEnable_promise)
//                .then(CarouselClearTimesLoading_promise)
//        )
//}

//function SubmitGuidedTourLead_action() {
//    return GuidedTourGenerateLeadPayload_promise()
//        .then(GuidedTourValidateLeadPayload_promise)
//        .then(SalesforceSchedulerLeadSubmit_promise)
//        .catch(err => {
//            //console.log("SubmitGuidedTourLead_action Error: " + err.Message);
//        })
//}

//function TourLockdown_promise(payload) {
//    return new Promise((resolve, reject) => {
//        $("#BookATourFirstName").prop("disabled", true);
//        $("#BookATourLastName").prop("disabled", true);
//        $("#BookATourEmail").prop("disabled", true);
//        $("#BookATourPhone").prop("disabled", true);
//        $("#BookATourNotes").prop("disabled", true);
//        $("#BookYourTourNow").prop("disabled", true);

//        //BookATourDisableCarousel();

//        $("#tour_schedule_virtual_tour_checkbox").prop("disabled", true);
//        $("#tour_schedule_inperson_tour_checkbox").prop("disabled", true);
//        $("#tour_schedule_duringbusinesshours_tour_checkbox").prop("disabled", true);
//        $("#tour_schedule_extendedhours_tour_checkbox").prop("disabled", true);

//        resolve(payload);
//    });
//}

//function TourUnlock_promise(payload) {
//    return new Promise((resolve, reject) => {
//        $("#BookATourFirstName").prop("disabled", false);
//        $("#BookATourLastName").prop("disabled", false);
//        $("#BookATourEmail").prop("disabled", false);
//        $("#BookATourPhone").prop("disabled", false);
//        $("#BookATourNotes").prop("disabled", false);
//        $("#BookYourTourNow").prop("disabled", false);
//        //BookATourEnableCarousel();

//        $("#tour_schedule_virtual_tour_checkbox").prop("disabled", false);
//        $("#tour_schedule_inperson_tour_checkbox").prop("disabled", false);
//        $("#tour_schedule_duringbusinesshours_tour_checkbox").prop("disabled", false);
//        $("#tour_schedule_extendedhours_tour_checkbox").prop("disabled", false);

//        resolve(payload);
//    });
//}

//function SelfGuidedTourLeadValidate_promise(payload) {

//    return new Promise((resolve, reject) => {
//        var errorMessage = "";
//        const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
//        const emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.+[a-zA-Z0-9.]/;

//        var firstName = $("#BookATourFirstName").val();
//        var lastName = $("#BookATourLastName").val();
//        var email = $("#BookATourEmail").val();
//        var phone = $("#BookATourPhone").val();
//        var notes = $("#BookATourNotes").val();
//        var community = $("#tour-schedule-metro-area-select").val();
//        var metro = $("#tour-schedule-community-select").val();

//        var valid = true;
//        //console.log("first name section");
//        //console.log(firstName);
//        if (firstName == null || firstName == "") {
//            valid = false;
//            errorMessage = errorMessage.concat("Error validating first name.\n");
//            $("#BookATourFirstNameError").show("slow");
//        }
//        else {
//            $("#BookATourFirstNameError").hide("slow");
//        }

//        if (lastName == null || lastName == "") {
//            valid = false;
//            errorMessage = errorMessage.concat("Error validating last name.\n");
//            $("#BookATourLastNameError").show("slow");
//        }
//        else {
//            $("#BookATourLastNameError").hide("slow");
//        }

//        if (email == null || email == "") {
//            valid = false;
//            //console.log("email empty");
//            errorMessage += "Please enter Email/n";
//            $("#BookATourEmailError").show("slow");
//        }
//        else {
//            if (!emailRegex.test(email)) {
//                valid = false;
//                //console.log("email regex failed");
//                errorMessage += "Error validating email/n";
//                $("#BookATourEmailError").show("slow");
//            }
//            else {
//                //console.log("email cleared");
//                $("#BookATourEmailError").hide("slow");
//            }
//        }

//        if (phone == null || phone == "") {
//            valid = false;
//            //console.log("phone empty");
//            errorMessage = errorMessage.concat("Error validating phone.\n");
//            $("#BookATourPhoneNumberError").show("slow");
//        }
//        else {
//            if (!phoneRegex.test(phone)) {
//                valid = false;
//                //console.log("phone regex failed");
//                errorMessage = errorMessage.concat("Error validating phone.\n");
//                $("#BookATourPhoneNumberError").show("slow");
//            }
//            else {
//                //console.log("phone cleared");
//                $("#BookATourPhoneNumberError").hide("slow");
//            }
//        }

//        if (community == null || community == "") {
//            valid = false;
//            errorMessage = errorMessage.concat("Error validating community.\n");
//        }

//        if (metro == null || metro == "") {
//            valid = false;
//            errorMessage = errorMessage.concat("Error validating metro.\n");

//        }

//        valid = (!$("#TourForm")[0].checkValidity()) ? false : valid;

//        if (valid == true) {
//            //console.log(" SelfGuidedTourLeadValidate_promise Resolved");
//            resolve(payload);
//        }
//        else {
//            //console.log("SelfGuidedTourLeadValidate_promise rejected ");
//            reject({ Message: errorMessage });
//        }
//    });
//}

//function DuringBusinessHoursTourGeneratePayload_promise() {
//    return new Promise((resolve, reject) => {
//        var payload = DuringBusinessHoursTourCreatePayload_promise();
//        resolve(payload);
//    });
//}

//function GuidedTourGenerateErrorPayload_promise() {
//    return new Promise((resolve, reject) => {
//        var payload = {
//            "appointmentBookingRequest":
//            {
//                "community_number": "8497",
//                "booking_date": "2/23/2022",
//                "booking_hour": 14,
//                "first_name": "test464",
//                "last_name": "test564",
//                "phone": "123-321-1234",
//                "email": "Error",
//                "appointment_type": "In Person Tour",
//                "notes": "test4",
//                "ga_client_id": "0000"
//            }
//        };
//        resolve(payload);
//    });
//}

//function GuidedTourGenerateSuccessPayload_promise() {
//    return new Promise((resolve, reject) => {
//        var payload = {
//            "appointmentBookingRequest":
//            {
//                "community_number": "8497",
//                "booking_date": "2/23/2022",
//                "booking_hour": 14,
//                "first_name": "test464",
//                "last_name": "test564",
//                "phone": "123-321-1234",
//                "email": "NOT ERROR",
//                "appointment_type": "In Person Tour",
//                "notes": "test4",
//                "ga_client_id": "0000"
//            }
//        };
//        resolve(payload);
//    });
//}

//function SalesforceSchedulerError101DisplayModal_promise(payload) {
//    return new Promise((resolve, reject) => {
//        $("#SalesforceTourSchedulerError101Wrapper").css({ "display": "unset" });
//        $("#SalesforceTourSchedulerError101").show("fast");
//        resolve(payload)
//    });
//}

//function DuringBusinessHoursDisplaySuccessModal_promise(payload) {
//    return new Promise((resolve, reject) => {
//        $("#DuringBusinessHoursModalWrapper").css({ "display": "unset" });
//        $("#DuringBusinessHoursModal").show();
//        resolve(payload)
//    });
//}

//function DuringBusinessHoursTourCreatePayload_promise() {
//    var payload = {
//        "FirstName": $("#BookATourFirstName").val(),
//        "LastName": $("#BookATourLastName").val(),
//        "EmailAddress": $("#BookATourEmail").val(),
//        "PhoneNumber": $("#BookATourPhone").val(),
//        "UnderstandTermsPrivacyPolicy": true,
//        "MetroArea": $("#tour-schedule-metro-area-select").val(),
//        "Community": $("#tour-schedule-community-select").val(),
//        "SitecoreItemId": "{4F6F91AB-ABCA-4174-8C8D-2E9C02D5ADF7}",
//        "ContactListId": $("#salesforce-tour-schedule-form-modal").data("contact-list"),
//        "TourType": "Self-Guided",
//        "ContactUserType": "Homebuyer",
//        "GaClientId": $("#salesforceTourSchedulerGAClientId").val()
//    };

//    return payload;
//}

//function SalesforceTourCarouselToggle(toggle) {
//    if (toggle) {
//        $("#SelectedDateDisplayWrapper").show("fast");
//        $("#mth-book-a-tour").show("fast");
//        if (!$("#salesforce-tour-schedule-form-modal").data("same-day"))
//            $("#SalesforceSchedulerBorder").show("fast");
//        $("#CarouselWrapper").show("fast");
//    }
//    else {
//        $("#SelectedDateDisplayWrapper").hide("fast");
//        $("#mth-book-a-tour").hide("fast");
//        $("#SalesforceSchedulerBorder").hide("fast");

//function SalesforceTourCarouselToggle(toggle) {
//    if (toggle) {
//        $("#SelectedDateDisplayWrapper").show("fast");
//        $("#mth-book-a-tour").show("fast");
//        if (!$("#salesforce-tour-schedule-form-modal").data("same-day"))
//            $("#SalesforceSchedulerBorder").show("fast");
//        $("#CarouselWrapper").show("fast");
//    }
//    else {
//        $("#SelectedDateDisplayWrapper").hide("fast");
//        $("#mth-book-a-tour").hide("fast");
//        $("#SalesforceSchedulerBorder").hide("fast");

//    }

//}

//function SalesforceTourFormToggle(toggle) {
//    if (toggle) {
//        $("#BookATourFirstName").prop("disabled", false);
//        $("#BookATourLastName").prop("disabled", false);
//        $("#BookATourEmail").prop("disabled", false);
//        $("#BookATourPhone").prop("disabled", false);
//        $("#BookATourNotes").prop("disabled", false);
//        $("#BookYourTourNow").prop("disabled", false);
//        $("#TourForm").prop("disabled", false);
//        $("#TourForm").show("fast");
//    }
//    else {
//        $("#BookATourFirstName").prop("disabled", true);
//        $("#BookATourLastName").prop("disabled", true);
//        $("#BookATourEmail").prop("disabled", true);
//        $("#BookATourPhone").prop("disabled", true);
//        $("#BookATourNotes").prop("disabled", true);
//        $("#BookYourTourNow").prop("disabled", true);
//        $("#TourForm").prop("disabled", true);
//        $("#TourForm").hide("fast");
//    }
//}

//function AppointmentOnlyFormEnabled() {
//    var SameDayTour = ($("#salesforce-tour-schedule-form-modal").data("same-day") == "True") ? true : false;
//    DuringBusinessHoursTourToggle(false);
//    GuidedTourToggle(false);
//    $("#GuidedTourCheckboxes").hide("fast");
//    SalesforceTourFormToggle(false);
//    $("#LikeToTour").hide("fast");
//    $("#NotFindingATime").hide("fast");

//    SelfGuidedTourToggle(true);
//}

//    SelfGuidedTourToggle(true);
//}

//function GuidedTourToggle(toggle) {
//    if (toggle) {
//        InPersonTourToggle(true);
//        VirtualTourToggle(true);
//        $("#GuidedTour").show("fast");
//        $("#GuidedTourWorkArea").show();
//        $("#GuidedTourCheckboxes").show("fast");
//        $("#CarouselWrapper").show();
//    }
//    else {
//        InPersonTourToggle(false);
//        VirtualTourToggle(false);
//        $("#GuidedTour").hide("fast");
//        $("#GuidedTourWorkArea").hide();
//        $("#GuidedTourCheckboxes").hide("fast");
//    }
//}

//function GuidedTourToggle(toggle) {
//    if (toggle) {
//        InPersonTourToggle(true);
//        VirtualTourToggle(true);
//        $("#GuidedTour").show("fast");
//        $("#GuidedTourWorkArea").show();
//        $("#GuidedTourCheckboxes").show("fast");
//        $("#CarouselWrapper").show();
//    }
//    else {
//        InPersonTourToggle(false);
//        VirtualTourToggle(false);
//        $("#GuidedTour").hide("fast");
//        $("#GuidedTourWorkArea").hide();
//        $("#GuidedTourCheckboxes").hide("fast");
//    }
//}

//function InPersonTourToggle(toggle) {
//    if (toggle) {
//        $("#tour_schedule_inperson_tour_checkbox").show();
//        $("#tour_schedule_inperson_tour_checkbox").prop("disabled", false);
//        $("#tour_schedule_inperson_tour_checkbox").unbind("click");
//        $("#tour_schedule_inperson_tour_checkbox").on("click", function () {
//            var origin = $(this).attr("id");
//            TourSchedulerRadioButtonChange(origin);
//        });
//    }
//    else {
//        $("#tour_schedule_inperson_tour_checkbox").hide();
//        $("#tour_schedule_inperson_tour_checkbox").prop("disabled", true);
//        $("#tour_schedule_inperson_tour_checkbox").unbind("click");
//    }
//}

//function VirtualTourToggle(toggle) {
//    if (toggle) {
//        $("#tour_schedule_virtual_tour_checkbox").show();
//        $("#tour_schedule_virtual_tour_checkbox").prop("disabled", false);
//        $("#tour_schedule_virtual_tour_checkbox").unbind("click");
//        $("#tour_schedule_virtual_tour_checkbox").on("click", function () {
//            var origin = $(this).attr("id");
//            TourSchedulerRadioButtonChange(origin);
//        });
//    }
//    else {
//        $("#tour_schedule_virtual_tour_checkbox").hide();
//        $("#tour_schedule_virtual_tour_checkbox").prop("disabled", true);
//        $("#tour_schedule_virtual_tour_checkbox").unbind("click");
//    }
//}

//function DuringBusinessHoursTourToggle(toggle) {
//    if (toggle) {
//        $("#DuringBusinessHoursWrapper").show();
//        $("#SalesforceSchedulerduringBusinessHoursRadioWrapper").show();
//        $("#tour_schedule_duringbusinesshours_tour_checkbox").prop("disabled", false);
//        $("#tour_schedule_duringbusinesshours_tour_checkbox").unbind("click");
//        $("#tour_schedule_duringbusinesshours_tour_checkbox").on("click", function () {
//            var origin = $(this).attr("id");
//            TourSchedulerRadioButtonChange(origin);
//        });
//    }
//    else {
//        $("#DuringBusinessHoursWrapper").hide();
//        $("#SalesforceSchedulerduringBusinessHoursRadioWrapper").hide();
//        $("#tour_schedule_duringbusinesshours_tour_checkbox").prop("disabled", true);
//        $("#tour_schedule_duringbusinesshours_tour_checkbox").unbind("click");
//    }
//}

//function SelfGuidedTourToggle(toggle) {
//    if ($("#salesforce-tour-schedule-form-modal").data("appointment-only") == "True") {
//        $("#SelfGuidedTitle").text("This community only offers self-guided tours. Schedule your appointment today");//check this out
//        $("#SalesforceTourSchedulerSubtitle").hide();
//    }
//    else {
//        $("#SelfGuidedTitle").text("Self-Guided Tour");
//        $("#SalesforceTourSchedulerSubtitle").show();
//    }

//    if (toggle) {
//        $("#SalesforceTourSchedulerRadioWrapper").show();
//        $("#tour_schedule_extendedhours_tour_checkbox").unbind("click");
//        $("#tour_schedule_extendedhours_tour_checkbox").on("click", function () {
//            var origin = $(this).attr("id");
//            TourSchedulerRadioButtonChange(origin);
//        });
//    }
//    else {
//        $("#SalesforceTourSchedulerRadioWrapper").hide();
//        $("#tour_schedule_extendedhours_tour_checkbox").unbind("click");
//    }

//}

//================================================= Form Posting Section End   =======================================//

//================================================= Agent Section Start   =======================================//

//function InitializeAgentSalesforceTourScheduler_promise(payload) {
//    return new Promise((resolve, reject) => {
//        SalesforceTourSchedulerDisplayHomeownerForm();
//        $("#tour_schedule_agent_checkbox").on("click", function () {
//            SalesforceTourSchedulerDisplayAgentForm();
//        });
//        $("#tour_schedule_homebuyer_checkbox").on("click", function () {
//            SalesforceTourSchedulerDisplayHomeownerForm();
//        });
//        resolve(payload);
//    });
//}

//function SalesforceTourSchedulerDisplayAgentForm() {

//    if ($("#HomebuyerCheckboxWrapper").hasClass("TourCheckboxSelected"))
//        $("#HomebuyerCheckboxWrapper").removeClass("TourCheckboxSelected")
//    if (!$("#HomebuyerCheckboxWrapper").hasClass("TourCheckbox"))
//        $("#HomebuyerCheckboxWrapper").addClass("TourCheckbox")

//    if (!$("#AgentCheckboxWrapper").hasClass("TourCheckboxSelected"))
//        $("#AgentCheckboxWrapper").addClass("TourCheckboxSelected")
//    if ($("#AgentCheckboxWrapper").hasClass("TourCheckbox"))
//        $("#AgentCheckboxWrapper").removeClass("TourCheckbox")

//    $("#SalesforceTourSchedulerDropdowns").hide("fast");
//    $("#SalesforceTourSchedulerSubtitle").hide("fast");
//    $("#SalesforceTourSchedulerHomeownerForm").hide("fast");
//    $("#LocationTitleWrapper").hide("fast");
//    $("#SalesforceTourSchedulerAgentForm").show("fast");
//}

//function SalesforceTourSchedulerDisplayHomeownerForm() {
//    if ($("#AgentCheckboxWrapper").hasClass("TourCheckboxSelected"))
//        $("#AgentCheckboxWrapper").removeClass("TourCheckboxSelected")
//    if (!$("#AgentCheckboxWrapper").hasClass("TourCheckbox"))
//        $("#AgentCheckboxWrapper").addClass("TourCheckbox")

//    if (!$("#HomebuyerCheckboxWrapper").hasClass("TourCheckboxSelected"))
//        $("#HomebuyerCheckboxWrapper").addClass("TourCheckboxSelected")
//    if ($("#HomebuyerCheckboxWrapper").hasClass("TourCheckbox"))
//        $("#HomebuyerCheckboxWrapper").removeClass("TourCheckbox")

//    if ($("#salesforce-tour-schedule-form-modal").data("appointment-only") == "True") {
//        $("#SalesforceTourSchedulerSubtitle").hide();
//    }
//    else {
//        $("#SelfGuidedTitle").text("Self-Guided Tour");
//        $("#SalesforceTourSchedulerSubtitle").show();
//    }
//    $("#SalesforceTourSchedulerAgentForm").hide("fast");
//    $("#SalesforceTourSchedulerDropdowns").show("fast");
//    $("#LocationTitleWrapper").show("fast");
//    $("#SalesforceTourSchedulerHomeownerForm").show("fast");
//}

//================================================= Agent Section End   =========================================//

//function CleanupDataAttributes() {
//    $("#SalesforceSubmitErrors").empty();
//    $('#BookYourTourNow').unbind('click');
//    $("#BookATourFirstName").val(null);
//    $("#BookATourLastName").val(null);
//    $("#BookATourEmail").val(null);
//    $("#BookATourPhone").val(null);
//    $("#BookATourNotes").val(null);
//    $("#BookATourNotes").val(null);
//    $("#mth-book-a-tour").data("selected-date", null);
//    $("#mth-book-a-tour").data("selected-date-time-value", null);
//    $("#mth-book-a-tour").removeData("selected-date");
//    $("#mth-book-a-tour").removeData("selected-date-time-value");
//    $("#TourSchedulerSalesOfficeHours").empty();
//}

//function ToggleTodayView(toggle) {
//    if (toggle) {
//        $("#GuidedTourCheckboxes").hide("fast");
//        $("#GuidedTourWorkArea").hide("fast");
//        $("#SalesforceSchedulerBorder").hide("fast");
//        $("#NotFindingATime").hide("fast");
//        $("#GuidedTour").hide("fast");
//        $("#SelfGuidedTitle").hide("fast");
//    }
//    else {
//        $("#SalesforceSchedulerBorder").show("fast");
//        $("#SelfGuidedTitle").show("fast");
//        $("#SameDayText").text(null);
//    }
//}

//function SalesforceSchedulerClearErrors() {
//    const errors = [
//        "#BookATourFirstNameError",
//        "#BookATourLastNameError",
//        "#BookATourEmailError",
//        "#BookATourPhoneNumberError"
//    ];

//    errors.forEach(errorDisplay => {
//        $(errorDisplay).hide("slow");
//    });
//}

//function AddFormLiveValidation() {

//    const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
//    const emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.+[a-zA-Z0-9.]/;

//    $("#BookATourEmail").keyup(function (e) {
//        const emailVal = e.currentTarget.value;
//        if (emailVal == null || emailVal == "")
//            $("#BookATourEmailError").show("slow");
//        else {
//            if (!emailRegex.test(emailVal))
//                $("#BookATourEmailError").show("slow");
//            else
//                $("#BookATourEmailError").hide("slow");
//        }
//    });
//    $("#BookATourPhone").keyup(function (e) {
//        const phoneVal = e.currentTarget.value;
//        if (phoneVal == null || phoneVal == "")
//            $("#BookATourPhoneNumberError").show("slow");
//        else {
//            if (!phoneRegex.test(phoneVal))
//                $("#BookATourPhoneNumberError").show("slow");
//            else
//                $("#BookATourPhoneNumberError").hide("slow");
//        }
//    });
//}

//function RemoveFormLiveValidation() {

//    $("#BookATourEmail").unbind("keyup");
//    $("#BookATourPhone").unbind("keyup");
//}

function formatPhoneNumber(phoneNumberString) {
    var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        var intlCode = match[1] ? "1-" : "";
        return [intlCode, , match[2], "-", match[3], "-", match[4]].join("");
    }
    return null;
}

function generateFullPostPayload() {
    var basicData = createBasicData();
    console.log("basicData");
    var agentData = $("#SFC_AgentCheckbox").is(":checked")
        ? [createAgentPayload()]
        : null;
    var homebuyerData = $("#SFC_HomebuyerCheckbox").is(":checked")
        ? [createBuyerPayload()]
        : null;

    var data = {
        formName: basicData.formName,
        metroArea: basicData.MetroArea,
        communityNumber: basicData.communmty_number,
        gaClientID: basicData.gaClientID,
        pagePath: basicData.pagePath,
        origin: basicData.origin,
        contactType: basicData.contact_type,
        primaryLeadSource: basicData.primaryLeadSource,
        leadSource: basicData.leadSource,
        subSource: basicData.subSource,
        gRecaptchaResponse: basicData.gRecaptchaResponse,
        preferredTourDatetime: basicData.preferredTourDatetime,
        notes: basicData.notes,
        tourAddress: basicData.tourAddress,
    };

    if (agentData != null) data["agents"] = agentData;
    if (homebuyerData != null) data["homebuyers"] = homebuyerData;

    console.log(data);
    return data;
}

function createBuyerPayload() {
    return {
        firstName: $("#HomebuyerFirstName").val(),
        lastName: $("#HomebuyerLastName").val(),
        phone: $("#HomebuyerMobilePhoneNumber").val(),
        email: $("#HomebuyerEmailAddress").val(),
        purchaseContingent: false,
        currentlyRenting: false,
        subscriptions: {
            newsletterSubscribe: false,
            metroAreaSubscribe: true,
            communitySubscribe: true,
        },
        smsOptInBuyer:
            $("#SFC_HomebuyerCheckbox").is(":checked") &&
                $("#SmsOptInBuyer").is(":checked")
                ? true
                : false,
    };
}



function createAgentPayload() {
    return {
        firstName: $("#AgentFirstName").val(),
        lastName: $("#AgentLastName").val(),
        phone: $("#AgentMobilePhoneNumber").val(),
        email: $("#AgentEmailAddress").val(),
        agentAgencyName: $("#AgentAgency").val(),
        purchaseContingent: false,
        currentlyRenting: false,
        subscriptions: {
            newsletterSubscribe: false,
            metroAreaSubscribe: true,
            communitySubscribe: true,
        },
        smsOptInAgent:
            $("#SFC_AgentCheckbox").is(":checked") &&
                $("#SmsOptInAgent").is(":checked")
                ? true
                : false,
    };
}


function createBasicData() {
    return {
        formName: "Request a Tour",
        metroArea: $("#TourSchedulerFor_MetroId").val(),
        communityNumber: $("#TourSchedulerFor_CommunityId").val(),
        gaClientId: $("#salesforceTourSchedulerGAClientId").val(),
        pagePath: $("#salesforceTourSchedulerPagePath").val(),
        origin: __origin,
        contactType: __contactType,
        primaryLeadSource: __primaryLeadSource,
        leadSource: DetermineLeadSource(),
        subSource: __subSource,
        gRecaptchaResponse: $("#requestTourRecaptchaResponse").val(),
        preferredTourDatetime: $("#PreferredDatetimeInput").val(),
        notes: $("#BookATourNotes").val(),
        tourAddress: $("#TourAddrestos").val(),
    };
}

function DetermineLeadSource() {
    if ($("#SFC_HomebuyerRadioBtn").is(":checked")) return "HomeBuyer";
    else return "Agent";
}